<template>
  <!-- 案件詳細 -->
  <div id="CpapRequestDetailEdit" v-if="data && data.patient">
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside">
        <table>
          <tr><th>申込日</th><td colspan="2">{{data.applicationDate}}　{{data.applicationUserName}}</td></tr>
          <tr><th>受付番号</th><td colspan="2">{{data.receiptNumber}}</td></tr>
          <!-- 見積情報リスト -->
          <tr v-if="data.estimateDetailCode.length==0"><th>見積情報</th></tr>
            <template v-for="(items,detailIndex) in data.estimateDetailCode">
            <tr :key="detailIndex" v-if="innerUser"><th style="width:15%;"><span v-if="detailIndex==0">見積情報</span></th>
              <td style="width:80%;">
                <span style="display:inline-block;width:20%;">{{items.estimateCode}}</span>
                <span style="display:inline-block;width:5%;padding-left:1%;">{{items.quotationDetailsNumber}}</span>
                <span style="display:inline-block;width:15%;padding-left:1%;">{{items.itemCode}}</span>
                <span style="display:inline-block;width:35%;padding-left:1%;">{{items.itemName}}</span>
                <span v-if="items.deliveryPrice" style="display:inline-block;width:15%;padding-left:1%;text-align:right;">￥{{items.deliveryPrice.toLocaleString()}}</span>
                <span v-else style="display:inline-block;width:15%;padding-left:1%;text-align:right;">￥0</span>
              </td>
            </tr>
          </template>
          <tr v-if="!isChangeValue"><th>申込み状況</th>
            <td colspan="2">
            <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
              {{getCpapProgres(data.status)}}
            </span>
            </td>
          </tr>
          <tr v-if="!isChangeValue && innerUser"><th>状態</th>
            <td colspan="2">
            <span :class="getCpapInnerStatusClass(data.status)" style="height:30px;margin-left:5px;width:20%;">
              {{getCpapStatus(data.status)}}
            </span>
            </td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && isResume && data.beforeItems && data.beforeItems.length > 0">
        <span style="font-size:20px;">転院前使用品目</span>
        <table>
          <tr>
            <th style="width:20%;">品目コード</th>
            <th style="width:30%;">品目名</th>
            <!-- <th style="width:25%;">見積詳細番号</th> -->
          </tr>
          <template v-for="(beforeItem,beforeItemIndex) in data.beforeItems">
            <tr :key="beforeItemIndex">
              <td>
                <span v-if="beforeItem.itemCode">{{beforeItem.itemCode}}</span>
                <span v-else style="color:red;">指示書未選択</span>
              </td>
              <td>{{beforeItem.itemName}}</td>
              <!-- <td>
                <span v-if="beforeItem.quotationDetailsNumber">{{beforeItem.quotationDetailsNumber}}</span>
                <span v-else style="color:red;">見積未選択</span>
              </td> -->
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && !isUser && directionsItemList && directionsItemList.length > 0" v-bind:key="renderKey">
      <!-- <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && directionsItemList && directionsItemList.length > 0" v-bind:key="renderKey"> -->
          <span style="font-size:20px;">品目情報</span>
          <div v-if="isResume" class="notice">
            ●転院前後で同じシリアルを使用する場合、見積選択後に「仮持出ID取得待ち」となります。機器選択は不要です。<br>
            ●転院前後で異なるシリアルを使用する場合、見積選択後に機器選択を行ってください。「仮持出選択済」となります。<br>
            &nbsp;&nbsp;転院前に使用していたシリアルは転院先の仮持出に入りますので、転院先にて機器回収を行ってください。</div>
          <div style="text-align:left;">
            <b-button style="margin-left:10px; width:150px; height:27px;" @click="bulkQuotationModalActive=true">一括選択</b-button>
          </div>
        <table>
          <tr>
            <th style="width:30%;">品目</th>
            <!-- <th style="width:30%;">品目名</th> -->
            <th style="width:20%;">見積選択</th>
            <th v-if="data.depositUseFlag" style="width:30%;">預託オーダーID</th>
            <th v-if="isTemp || isResume" style="width:30%;">仮持出ID</th>
            <th v-if="!((data.depositUseFlag)||(isTemp || isResume))" style="width:6%;text-align:center;">出荷指示</th>
            <th v-else-if="(data.depositUseFlag)||(isTemp || isResume)" style="width:6%;text-align:center;">レンタル<br>処理指示</th>
            <th style="width:6%;text-align:center;">回収指示</th>
          </tr>
          <template v-for="(directionsItem,directionsItemIndex) in directionsItemList">
            <tr :key="directionsItemIndex" :class="{'emphasis': directionsItem.shippingInstructionsFlg && isEscrow}">
              <td>
                <span v-if="directionsItem.itemCode">{{directionsItem.itemCode}}</span>
                <span v-else style="color:red;">指示書未選択</span>
                ：{{directionsItem.name}}
              </td>
              <td>
                <span v-if="directionsItem.estimateCode">見積選択済</span>
                <span v-else style="color:red;">見積未選択</span>
                <b-button v-if="directionsItem.estimateCode" class="clearBtn" icon-left="eraser" @click="deleteQuotation(directionsItem.itemCode, directionsItem.name, directionsItemIndex)"></b-button>
                <span v-else style="display: inline-block; width:35px;"></span>
              </td>
              <td v-if="data.depositUseFlag">
                <span v-if="directionsItem.depositUseOrderId" style="display: inline-block; width:110px;">オーダー選択済</span>
                <span v-else style="color:red;display: inline-block; width:110px;">オーダー未選択</span>
                <b-button v-if="directionsItem.quotationDetailsNumber" style="margin-left:5px; width:120px; height:27px;" v-on:click="orderSelectModalOn(directionsItem.depositUseOrderId, directionsItem.itemCode)">オーダー選択</b-button>
                <b-button v-if="directionsItem.quotationDetailsNumber && directionsItem.depositUseOrderId" class="clearBtn" icon-left="eraser" @click="deleteDepositUseOrderInfo(directionsItem.depositUseOrderId, directionsItem.itemCode)"></b-button>
                <span v-else style="display: inline-block; width:33px;"></span>
              </td>
              <td v-if="isTemp || isResume">
                <span v-if="directionsItem.quotationDetailsNumber">
                  <span v-if="directionsItem.tempDeviceId" style="display: inline-block; width:120px;">仮持出選択済</span>
                  <span v-else-if="!directionsItem.tempDeviceId && resumeExchangeCheck(directionsItem.itemCode)" style="display: inline-block; width:120px;">仮持出ID取得待ち</span>
                  <span v-else style="display: inline-block; width:120px;">仮持出なし</span>
                  <b-button style="margin-left:5px; width:100px; height:27px;" v-on:click="tempDeviceModalOn(directionsItem.itemCode, directionsItem.serial)">機器選択</b-button>
                  <b-button v-if="directionsItem.tempDeviceId" class="clearBtn" icon-left="eraser" @click="deleteTempDeviceInfo(directionsItem.itemCode, directionsItemIndex)"></b-button>
                  <span v-else style="display: inline-block; width:33px;"></span>
                </span>
              </td>
              <td>
                <span style="display:inline-block; text-align:center; width:100%;"><b-checkbox v-model="directionsItem.shippingInstructionsFlg" :disabled="estimateDisabled(directionsItem.itemCode, directionsItem.estimateCode, 'shipping')" @input="onlyCollectionCheck"></b-checkbox></span>
              </td>
              <td>
                <span style="display:inline-block; text-align:center; width:100%;"><b-checkbox v-model="directionsItem.collectionInstructionsFlg" :disabled="estimateDisabled(directionsItem.itemCode, directionsItem.estimateCode, 'collection')"></b-checkbox></span>

              </td>
            </tr>
          </template>
        </table>
        <span v-if="isEscrow">※レンタル処理指示にチェックが入っている場合は、見積および預託オーダーを選択してください。<br>選択した預託オーダーを契約変更処理にてレンタル計上します。</span>
        <div v-if="isEscrow && serialExchangeFlag" style="font-size:20px; color:red;">シリアルが交換されている機器がありますので、見積もり削除の上、<br>レンタル処理指示および回収指示両方をチェックしてください。</div>
        <!-- QA69 20231227 -->
        <span  v-if="!data.depositUseFlag && !isTemp" style="color:red; font-size:14px;">※川越にCPAP本体を発送依頼する場合は、標準の回路は同梱されているため、回路を別途見積連携する必要はありません。<br>（HTなど標準の回路でないものは見積選択が必要です。）</span>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">基本情報</span>
        <table>
          <tr><th>指示日<span class="require"/></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('basicArea','instructionDate')" class="change"></span></td><td><input type="date" v-model="data.instructionDate" class="1" :name="'指示日'" validate="required|date" style="width:150px;"/></td></tr>
          <!-- 預託機使用の場合 -->
          <!-- <template v-if="data.depositUseFlag"> -->
          <!-- 外部ユーザーでは非表示20240329 -->
          <template v-if="data.depositUseFlag && innerUser">
            <tr>
              <th>契約終了日<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('basicArea','depositContractEndDate')" class="change"></span></td>
              <td><input type="date" v-model="data.depositContractEndDate" :min="data.contractEndMin" style="width:150px;" class="1" name="契約終了日" validate="required|date" /></td>
            </tr>
            <tr>
            <!-- <tr v-if="innerUser"> -->
              <th>当月請求<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('basicArea','depositBillingCurrentMonth')" class="change"></span></td>
              <td>
                <select id="billingCurrentMonth" class="1" name="当月請求" validate="required" v-model="data.depositBillingCurrentMonth">
                  <option v-for="billed in billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.text }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>契約取消理由<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('basicArea','depositCancelReasonCode')" class="change"></span></td>
              <td>
                <select v-model="data.depositCancelReasonCode" class="1" name="契約取消理由" validate="required">
                  <option></option>
                  <option v-for="cancelCode in cancelCodeMaster" :value="cancelCode.value" :key="cancelCode.value">{{ cancelCode.text }}</option>
                </select>
              </td>
            </tr>
          </template>
          <tr><th>申請元医療機関名</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('basicArea','medicalInstitutionName')" class="change"></span></td><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.medicalInstitutionName}}</td></tr>
          <tr><th>医師名<span class="require"/></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('basicArea','doctorName')" class="change"></span></td><td><input type="text" class="1" name="医師名" validate="required" v-model="data.doctorName" maxlength="256" /></td></tr>
          <tr><th>事務担当者名</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('basicArea','clerkName')" class="change"></span></td><td><input type="text" v-model="data.clerkName" maxlength="256" /></td></tr>
          <tr v-if="innerUser && comment"><th>コメント</th><td></td><td>{{data.note}}</td></tr>
          <template v-if="data.isDealer">
            <tr><th>医療機関メールアドレス</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('basicArea','mailNotification')" class="change"></span></td><td><b-checkbox class="cstmCheckBox" v-model="data.mailNotification">申込み内容を医療機関にメールで通知する。</b-checkbox></td></tr>
            <tr v-if="data.mailNotification"><th></th><td></td><td><input type="text" v-model="data.hospitalMail" maxlength="256" placeholder="例）example@example.com" class="1" name="医療機関メールアドレス" validate="mail|required"></td></tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">患者情報</span>
        <table>
          <tr><th>患者コード<span class="require"/></th>
          <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','patientCode')" class="change"></span></td>
            <td>
              <input type="text" style="width:600px;" v-model="data.patientCode" disabled />
              <b-button v-if="innerUser&&data.patientCodeStatus==cpapPatientRegisterStatus.registRequest" style="margin-left:10px; width:150px; height:27px;" @click="patientModalActive=true">患者選択</b-button>
            </td>
          </tr>
          <tr><th>診察券ID（患者ID）<span class="require" /></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','patientRegistrationCard')" class="change"></span></td><td><input type="text" v-model="data.patient.patientRegistrationCard" maxlength="50" class="1" :name="'診察券ID（患者ID）'" validate="required" /></td></tr>
          <tr><th>患者名<span class="require" /></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (singleChangedCheck('patientArea','patientFamilyName') || singleChangedCheck('patientArea','patientFirstName'))" class="change"></span></td><td><input type="text" style="margin-right: 5px; width: 435px !important;" placeholder="姓" v-model="data.patient.patientFamilyName" class="1" :name="'患者名(姓)'" validate="required" maxlength="49"/><input type="text" style="width: 435px !important;" placeholder="名" v-model="data.patient.patientFirstName" class="1" :name="'患者名(名)'" validate="required" maxlength="49" @blur="focusLostPatientFirstName()"/></td></tr>
          <tr><th>患者名（カナ）<span class="require" /></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (singleChangedCheck('patientArea','patientFamilyNameKana') || singleChangedCheck('patientArea','patientFirstNameKana'))" class="change"></span></td><td><input type="text" style="margin-right: 5px; width: 435px !important;" placeholder="セイ" v-model="data.patient.patientFamilyNameKana" class="1" :name="'患者名カナ(セイ)'" validate="kana|required" maxlength="49"/><input type="text" style="width: 435px !important;" placeholder="メイ" v-model="data.patient.patientFirstNameKana" class="1" :name="'患者名カナ(メイ)'" validate="kana|required" maxlength="49"/></td></tr>
          <tr><th>性別<span class="require" /></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','gender')" class="change"></span></td><td>
            <div class="block">
              <b-radio size="is-small" v-model="data.patient.gender" native-value="-">-</b-radio>
              <b-radio size="is-small" v-model="data.patient.gender" native-value="男">男</b-radio>
              <b-radio size="is-small" v-model="data.patient.gender" native-value="女">女</b-radio>
            </div></td>
          </tr>
          <tr><th>生年月日<span class="require"/></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','birthday')" class="change"></span></td><td><input type="date" v-model="data.patient.birthday" :input="inputBirthday(data.patient.birthday)" class="1" :name="'患者の生年月日'" validate="required|date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;"/><span v-if="data.patient.birthday" style="margin-left:10px;">{{data.patient.japaneseCalendar}}</span></td></tr>
          <tr><th>年齢</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','age')" class="change"></span></td><td><input type="text" disabled v-model="data.patient.age"/></td></tr>
          <tr>
            <th>郵便番号<span class="require"/></th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','zip')" class="change"></span></td>
            <td>
              <input
                v-model="data.patient.zip"
                type="text"
                maxlength="7"
                style="width: 270px;"
                class="1"
                :class="{'border-red': invalidPatientPostcode}"
                :name="'患者の郵便番号'"
                validate="required|numeric"
                :placeholder="postcodePlaceholder"
              />
              <b-button style="margin-left:10px; width:150px; height:27px;" v-on:click="patientAddressSearch(data.patient.zip)">郵便番号検索</b-button>
              <!--  移行データ バリデーションなし 20240117 -->
              <div v-if= "data.existingFlag" v-show="invalidPatientPostcode" class="text-red"></div>
              <div v-else-if= "!data.existingFlag" v-show="invalidPatientPostcode" class="text-red">{{ invalidNumberMessage }}</div>
            </td>
          </tr>
          <tr><th>住所<span class="require"/></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','address')" class="change"></span></td><td><input type="text" v-model="data.patient.address" maxlength="256" class="1" :name="'患者の住所'" validate="required"/></td></tr>
          <tr><th>住所（丁目、番地）<span class="require"/></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','address1')" class="change"></span></td><td><input type="text" v-model="data.patient.address1" maxlength="256" class="1" :name="'患者の住所（丁目、番地）'" validate="required"/></td></tr>
          <tr><th>住所（建物名、号室）</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','address2')" class="change"></span></td><td><input type="text" v-model="data.patient.address2" maxlength="256"/></td></tr>
          <tr v-if="!data.depositUseFlag"><th>納品先宛名<span class="require"/></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','receiverName')" class="change"></span></td><td><input type="text" v-model="data.patient.receiverName" maxlength="100" class="1" :name="'納品先宛名'" validate="required"/></td></tr>
          <tr v-if="!data.depositUseFlag && innerUser" style="height:15px;"><th></th><td></td><td style="font-size:11px; color:red; padding:0px;">川越出荷時はこの宛名を使用しますので、誤りがないように必ず確認してください。</td></tr>
          <tr>
            <th>連絡先（携帯電話）</th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','mobilePhone')" class="change"></span></td>
            <td>
              <input
                type="text"
                v-model="data.patient.mobilePhone"
                maxlength="11"
                id="mobilePhone"
                class="1"
                :class="{'border-red': invalidPatientMobilePhone}"
                name="連絡先（携帯電話）"
                validate="numeric"
                :placeholder="phonePlaceholder"
              />
              <!--  移行データ バリデーションなし 20240117 -->
              <div v-if= "data.existingFlag" v-show="invalidPatientMobilePhone" class="text-red"></div>
              <div v-else-if= "!data.existingFlag" v-show="invalidPatientMobilePhone" class="text-red">{{ invalidNumberMessage }}</div>
            </td>
          </tr>
          <tr>
            <th>連絡（自宅・その他）</th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','phoneNumber')" class="change"></span></td>
            <td>
              <input
                type="text"
                v-model="data.patient.phoneNumber"
                maxlength="11"
                id="phoneNumber"
                class="1"
                :class="{'border-red': invalidPatientPhoneNumber}"
                name="連絡（自宅・その他）"
                validate="numeric"
                :placeholder="phonePlaceholder"
              />
              <!--  移行データ バリデーションなし 20240117 -->
              <div v-if= "data.existingFlag" v-show="invalidPatientPhoneNumber" class="text-red"></div>
              <div v-else-if= "!data.existingFlag" v-show="invalidPatientPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
            </td>
          </tr>
          <tr><th>フォローアップコール<span class="require"/></th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','followUpCall')" class="change"></span></td>
            <td>
              <div>
                <b-radio class="td_radio" name="followUpCall" v-model="data.patient.followUpCall" :native-value="true">する</b-radio>
                <b-radio class="td_radio" name="followUpCall" v-model="data.patient.followUpCall" :native-value="false">しない</b-radio>
              </div>
            </td>
          </tr>
          <tr><th>病名</th>
          <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','disease')" class="change"></span></td>
            <td>
              <input type="text" v-model="data.patient.disease" maxlength="256"/>
            </td>
          </tr>
          <tr><th>感染症</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','infection')" class="change"></span></td><td>
            <select v-model="data.patient.infection">
              <option value=""/>
              <option value="0">無し</option>
              <option value="1">MRSA</option>
              <option value="2">HCV</option>
              <option value="3">HBV</option>
              <option value="4">Wa</option>
              <option value="5">その他</option>
            </select>
          </td></tr>
          <tr><th>感染症名</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','infectionName')" class="change"></span></td><td><input type="text" v-model="data.patient.infectionName" maxlength="256" class="1" name="感染症名" :validate="`${data.patient.infectionFlag ? 'required' : ''}`"/></td></tr>
          <tr><th>地域医療連携施設名</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','hospitalName')" class="change"></span></td><td><input type="text" v-model="data.patient.hospitalName" maxlength="256" /></td></tr>
          <tr><th>地域医療連携施設　医師名</th><td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('patientArea','doctorName')" class="change"></span></td><td><input type="text" v-model="data.patient.doctorName" maxlength="105"/></td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">装置情報</span>
        <table>
          <template v-if="(isTemp || isResume)">
            <!-- 仮持出 -->
            <tr><th>機種<span class="require"/></th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('hardwareArea','reportFormatType')" class="change"></span></td>
              <td>
                <input disabled style="width:80%;" type="text" :value="getMachineName()" data-vv-as="機種" class="1" name="機種" validate="required"/>
                <b-button style="margin-left:10px; width:150px; height:27px;" v-on:click="tempDeviceChange(0, true)">機器選択</b-button>
              </td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;">シリアル<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('hardwareArea','serial')" class="change"></span></td>
              <td>
                <input disabled style="width:80%;" type="text" maxlength="18" v-model="data.serial" data-vv-as="CPAP機器シリアル" class="1" name="シリアル" validate="required"/>
              </td>
            </tr>
          </template>
          <template v-else>
            <!-- 仮持出以外 -->
            <tr><th>機種<span class="require"/></th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('hardwareArea','reportFormatType')" class="change"></span></td>
              <td>
                <select id="model" class="1" name="機種" validate="required" @change="changeModel" v-model="data.reportFormatType">
                  <option v-for="model in modelList" :value="model.reportFormatType" :key="model.reportFormatType">{{ model.itemName }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th style="white-space:pre-wrap;">シリアル<span v-if="isRequiredSerial() || isEscrow" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('hardwareArea','serial')" class="change"></span></td>
              <td>
                <span v-if="isRequiredSerial()">
                  <input type="text" data-vv-as="CPAP機器シリアル" maxlength="18" :disabled="!data.depositUseFlag" v-model="data.serial" class="1" name="シリアル" validate="required"/>
                </span>
                <span v-else>
                  <input type="text" data-vv-as="CPAP機器シリアル" maxlength="18" v-model="data.serial" name="シリアル"/>
                  <!-- :disabled="isChangeValue" -->
                </span>
              </td>
            </tr>
          </template>
          <!--
          <template>
            <tr>
              <th>使用機器</th><td><b-checkbox class="cstmCheckBox" v-model="data.depositUseFlag">預託機を使用する（要預託契約）</b-checkbox></td>
            </tr>
          </template>
          -->
          <!-- 設定変更対応欄不要　20230822 -->
          <!-- 処方変更の場合 --> 
          <!-- <template v-if="isChangeValue || data.kind == cpapKindMap.applicationChange">
            <tr>
              <th>設定変更対応<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('hardwareArea','settingChanger')" class="change"></span></td>
              <td>
                <div class="block">
                  <b-radio v-model="data.settingChanger" :native-value=0>医療機関にて対応済</b-radio>
                  <b-radio v-model="data.settingChanger" :native-value=1>Philipsへ対応依頼</b-radio>
                </div>
              </td>
            </tr>
          </template> -->
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">設定情報</span>
        <table id="prescriptionTable">
          <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===0})">
            <!-- テキスト項目 -->
            <tr v-if="content.type==='char' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="((data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('prescriptionArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form2char_'+index)&&!content.disabled}"
                :message="`${errors.has('form2char_'+index)&&!content.disabled ? errors.first('form2char_'+index) : ''}`">
                  <input
                    style="width:500px;"
                    type="text"
                    :name="'form2char_'+index"
                    :data-vv-as="content.displayName"
                    v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`"
                    v-model="content.value"
                    @input="changeSelect(content.displayName,content.value,content.itemName)"
                    :disabled="content.disabled"/>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- セレクトボックス -->
            <tr v-if="content.type=== 'sel' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="((data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('prescriptionArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form2sel_'+index)&&!content.disabled}"
                :message="`${errors.has('form2sel_'+index)&&!content.disabled ? errors.first('form2sel_'+index) : ''}`">
                  <select 
                  style="width:500px;"
                  :name="'form2sel_'+index"
                  :data-vv-as="content.displayName"
                  v-model="content.value"
                  v-validate="`${content.required ? 'required':''}`"
                  @change="changeSelect(content.displayName,content.value,content.itemName)"
                  :disabled="content.disabled">
                    <option
                    v-for="tmpValue in content.displayValue"
                    :value="tmpValue.key"
                    :key="tmpValue.key"
                    >{{ tmpValue.value }}</option></select>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- カレンダー -->
            <tr v-if="content.type=== 'calender' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="((data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('prescriptionArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form2calender_'+index)}"
                :message="errors.first('form2calender_'+index)">
                  <input style="width:500px;" type="date" :name="'form2calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- ラジオボタン -->
            <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="((data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('prescriptionArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <div>
                  <b-radio
                  v-for="tmpValue in content.displayValue"
                  v-model="content.value"
                  :value="tmpValue.value"
                  :key="tmpValue.key"
                  :name="'form2radio_'+index+'_'"
                  :native-value="tmpValue.key"
                  style="text-align:left; margin-Right:10px;"
                  >{{tmpValue.value}}</b-radio>
                </div>
                <!-- :disabled="content.isDisabled=='true'" -->
              </td>
            </tr>
            <tr v-if="content.annotation" :key="index+'α'">
              <td style="white-space:pre-wrap;color:red;" colspan="3">{{content.annotation}}</td>
            </tr>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">加温加湿器</span>
        <div v-if="data.useMoist" style="font-size:20px; color:red;">※ヒーターチューブ付加温加湿を選択する際は、呼吸回路タイプを15Hに変更してください。<br>（加湿モードでヒーターチューブ付加温加湿を選択できる機器の場合も呼吸回路タイプの変更が必要です。）</div>
        <table>
          <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===1})">
            <!-- テキスト項目 -->
            <tr v-if="content.type==='char' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moistArea') || singleChangedCheck('moistArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3char_'+index)}"
                :message="errors.first('form3char_'+index)">
                  <input style="width:500px;" type="text" :name="'form3char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                  <!-- <span v-if="errors.has('char_'+index)" style="color:red;">{{errors.first('char_'+index)}}</span> -->
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- セレクトボックス -->
            <tr v-if="content.type=== 'sel' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moistArea') || singleChangedCheck('moistArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3sel_'+index)}"
                :message="errors.first('form3sel_'+index)">
                  <select
                  style="width:500px;"
                  :name="'form3sel_'+index"
                  :data-vv-as="content.displayName"
                  v-model="content.value"
                  v-validate="`${content.required ? 'required':''}`"
                  @change="changeSelect(content.displayName,content.value,content.itemName)"
                  :disabled="content.disabled">
                    <option
                    v-for="tmpValue in content.displayValue"
                    :value="tmpValue.key"
                    :key="tmpValue.key"
                    >{{ tmpValue.value }}</option></select>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- カレンダー -->
            <tr v-if="content.type=== 'calender' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moistArea') || singleChangedCheck('moistArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3calender_'+index)}"
                :message="errors.first('form3calender_'+index)">
                  <input style="width:500px;" type="date" :name="'form3calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- ラジオボタン -->
            <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moistArea') || singleChangedCheck('moistArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
              <td>
                <div>
                  <b-radio
                  v-for="tmpValue in content.displayValue"
                  v-model="content.value"
                  :value="tmpValue.value"
                  :key="tmpValue.key"
                  :name="'form3radio1_'+index"
                  :native-value="tmpValue.key"
                  style="text-align:left; margin-Right:10px;"
                  @click.native="inputRadioValue(tmpValue.key,'useMoist')"
                  >{{tmpValue.value}}</b-radio>
                </div>
                <!-- :disabled="content.isDisabled=='true'" -->
              </td>
            </tr>
          </template>
          <tr v-if="data.useMoist">
            <th style="white-space:pre-wrap;">品目コード</th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moistArea') || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
            <td>
              <input style="width:500px;" type="text" disabled data-vv-as="加湿器品目コード" maxlength="20" v-model="data.moistItemCode"/>
            </td>
          </tr>
          <tr v-if="data.useMoist">
            <th v-if="isEscrow" style="white-space:pre-wrap;">シリアル<span class="require"/></th>
            <th v-else style="white-space:pre-wrap;">シリアル</th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moistArea') || singleChangedCheck('moistArea','moistSerial') || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
            <td v-if="isEscrow" >
              <input style="width:500px;" type="text" data-vv-as="加湿器シリアル" maxlength="20" v-model="data.moistSerial" class="1" name="シリアル" validate="required"/>
            </td>
            <td v-else>
              <!-- <input style="width:500px;" type="text" data-vv-as="加湿器シリアル" maxlength="20" v-model="data.moistSerial" :disabled="isChangeValue"/> -->
              <input style="width:500px;" type="text" :disabled="data.depositUseFlag || isTemp || isResume" data-vv-as="加湿器シリアル" maxlength="20" v-model="data.moistSerial"/>
            </td>
          </tr>
          <!-- 仮持出の場合 機器、付属品のシリアル入力/選択する -->
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">通信モジュール</span>
        <div v-if="(simultaneousExchangeCheck() && !saveSimultaneousExchangeCheck()) || simultaneousExchangeCheck2()" style="font-size:20px; color:red;">※本体交換の為、モデムも交換します 交換用のデータを入力して下さい</div>
        <table>
          <template v-for="(content, index) in data.prescriptionItems.filter(val=>{ return val.category===2})">
            <!-- テキスト項目 -->
            <tr v-if="content.type==='char' && data.useModule && !isHideItem(content.displayName)  && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || singleChangedCheck('moduleArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType') || modulchangedCheck('moduleArea'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3_2char_'+index)}"
                :message="errors.first('form3_2char_'+index)">
                  <input style="width:500px;" type="text" :name="'form3_2char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- セレクトボックス -->
            <tr v-if="content.type=== 'sel' && data.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || singleChangedCheck('moduleArea',content.displayName)  || singleChangedCheck('hardwareArea','reportFormatType') || modulchangedCheck('moduleArea'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3_2sel_'+index)}"
                :message="errors.first('form3_2sel_'+index)">
                  <select style="width:500px;" :name="'form3_2sel_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`">
                    <option
                    v-for="tmpValue in content.displayValue"
                    :value="tmpValue.key"
                    :key="tmpValue.key"
                    >{{ tmpValue.value }}</option></select>{{content.unit}}
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- カレンダー -->
            <tr v-if="content.type=== 'calender' && data.useModule && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || singleChangedCheck('moduleArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType') || modulchangedCheck('moduleArea'))" class="change"></span></td>
              <td>
                <b-field
                :type="{'is-danger':errors.has('form3_2calender_'+index)}"
                :message="errors.first('form3_2calender_'+index)">
                  <input style="width:500px;" type="date" :name="'form3_2calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                </b-field>
              </td>
              <td>
                <!-- 説明コメント用 -->
              </td>
            </tr>
            <!-- ラジオボタン -->
            <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || singleChangedCheck('moduleArea',content.displayName) || singleChangedCheck('hardwareArea','reportFormatType') || modulchangedCheck('moduleArea'))" class="change"></span></td>
            
              <td>
                <div>
                  <b-radio
                  v-for="tmpValue in content.displayValue"
                  v-model="content.value"
                  :value="tmpValue.value"
                  :key="tmpValue.key"
                  :name="'form3_2radio2_'+index"
                  :native-value="tmpValue.key"
                  :disabled="data.reportFormatType==6"
                  style="text-align:left; margin-Right:10px;"
                  @click.native="inputRadioValue(tmpValue.key,'useModule')"
                  >{{tmpValue.value}}</b-radio>
                </div>
                <!-- :disabled="content.isDisabled=='true'" -->
              </td>
            </tr>
          </template>
          <!-- 内部ユーザーのみ表示する20230913 -->
          <template v-if="innerUser || isEscrow">
            <!-- 預託処方変更の場合 -->
            <template v-if="isEscrow && data.useModule">
              <tr>
                <th style="white-space:pre-wrap;">機種<span class="require"/></th>
                <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || modulchangedCheck('moduleArea') || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
                <td v-if="moduleList">
                  <b-field :type="{'is-danger':errors.has('moduleItemCode')}" :message="errors.first('moduleItemCode')">
                    <select style="width:500px;" name="moduleItemCode" data-vv-as="通信モジュール機種" v-validate="'required'" v-model="data.moduleItemCode" @change="getDirectionsItemList">
                      <option v-for="val in moduleList" :value="val.itemCode" :key="val.itemCode">{{ val.itemName }}</option>
                    </select>
                  </b-field>
                </td>
                <td v-else>
                  <input style="width:500px;" type="text" disabled data-vv-as="通信モジュール品目コード" maxlength="20" v-model="data.moduleItemCode"/>
                </td>
              </tr>
              <tr>
                <!-- <th style="white-space:pre-wrap;">シリアル<span class="require"/></th> -->
                <th style="white-space:pre-wrap;">シリアル<span v-if="this.data.reportFormatType != 3" class="require"/></th>
                <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || singleChangedCheck('moduleArea','moduleSerial') || singleChangedCheck('hardwareArea','reportFormatType') || modulchangedCheck('moduleArea'))" class="change"></span></td>
                <td>
                  <!-- <input style="width:500px;" type="text" data-vv-as="通信モジュールシリアル" maxlength="20" v-model="data.moduleSerial" class="1" name="シリアル" validate="required"/> -->
                  <input v-if="this.data.reportFormatType != 3" style="width:500px;" type="text" data-vv-as="通信モジュールシリアル" maxlength="20" v-model="data.moduleSerial" class="1" name="シリアル" validate="'required'"/>
                  <input v-else style="width:500px;" type="text" disabled data-vv-as="通信モジュールシリアル" maxlength="20" v-model="this.data.moduleSerial" name="シリアル"/>
                </td>
              </tr>
              <!-- 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
              <tr>
                <th style="white-space:pre-wrap;">院内在庫選択</th>
                <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('hardwareArea','serial')" class="change"></span></td>
                <td>
                  <select style="width:500px;" id="model" name="モジュール" validate="required" @change="selectionStock($event, data.moduleItemCode, 'module')" v-model="data.moduleItemCode">
                    <option></option>
                    <option v-for="(model,index) in escrowStockList" :value="model.itemCode" :key="index">{{ model.itemName }} : {{ model.serial }}</option>
                  </select>
                </td>
              </tr> -->
            </template>
            <!-- 預託処方変更以外 -->
            <template v-else>
              <tr v-if="data.useModule && (data.moduleItemCode || moduleList)">
                <th style="white-space:pre-wrap;">機種<span class="require"/></th>
                <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || modulchangedCheck('moduleArea') || singleChangedCheck('hardwareArea','reportFormatType'))" class="change"></span></td>
                <td v-if="moduleList">
                  <b-field :type="{'is-danger':errors.has('moduleItemCode')}" :message="errors.first('moduleItemCode')">
                    <select style="width:500px;" name="moduleItemCode" data-vv-as="通信モジュール機種" v-validate="'required'" v-model="data.moduleItemCode" @change="getDirectionsItemList">
                      <option v-for="val in moduleList" :value="val.itemCode" :key="val.itemCode">{{ val.itemName }}</option>
                    </select>
                  </b-field>
                </td>
                <td v-else>
                  <input style="width:500px;" type="text" disabled data-vv-as="通信モジュール品目コード" maxlength="20" v-model="data.moduleItemCode"/>
                </td>
              </tr>
              <tr v-if="data.useModule">
                <th style="white-space:pre-wrap;">シリアル</th>
                <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && (addCheck('moduleArea') || singleChangedCheck('moduleArea','moduleSerial') || singleChangedCheck('hardwareArea','reportFormatType') || modulchangedCheck('moduleArea'))" class="change"></span></td>
                <td>
                  <!-- <input style="width:500px;" type="text" data-vv-as="通信モジュールシリアル" maxlength="20" v-model="data.moduleSerial" :disabled="isChangeValue"/> -->
                  <input style="width:500px;" type="text" :disabled="data.depositUseFlag || isTemp || isResume" data-vv-as="通信モジュールシリアル" maxlength="20" v-model="data.moduleSerial"/>
                </td>
              </tr>
            </template>
          </template>
          <!-- 仮持出の場合 機器、付属品のシリアル入力/選択する -->
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">マスク</span>
        <table>
          <tr>
            <th style="white-space:pre-wrap;width:250px;">マスク：種類<span class="require"/></th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('maskArea','maskType')" class="change"></span></td>
            <td>
              <b-field :type="{'is-danger':errors.has('form4.form4_3char_maskType')}" :message="errors.first('form4.form4_3char_maskType')">
                <input disabled style="width:500px;" type="text" name="form4_3char_maskType" data-vv-as="マスク種類" v-validate="`'required'`" v-model="data.maskType"/>
                <b-button type="is-primary" style="margin-left:10px; width:150px; height:27px;" v-on:click="getMaskMaster()">マスク選択</b-button>
              </b-field>
            </td>
            <td>
            </td>
          </tr>
          <tr>
            <th style="white-space:pre-wrap;width:250px;">マスク：クッションサイズ<span class="require"/></th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('maskArea','cushionSize')" class="change"></span></td>
            <td>
              <b-field :type="{'is-danger':errors.has('form4.form4_3char_cushionSize')}" :message="errors.first('form4.form4_3char_cushionSize')">
                <input disabled style="width:500px;" type="text" name="form4_3char_cushionSize" data-vv-as="クッションサイズ" v-validate="`'required'`" v-model="data.cushionSize"/>
              </b-field>
            </td>
            <td></td>
          </tr>
          <tr>
            <th style="white-space:pre-wrap;width:250px;">マスク：フレームサイズ<span class="require"/></th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('maskArea','frameSize')" class="change"></span></td>
            <td>
              <b-field :type="{'is-danger':errors.has('form4.form4_3char_frameSize')}" :message="errors.first('form4.form4_3char_frameSize')">
                <input disabled style="width:500px;" type="text" name="form4_3char_frameSize" data-vv-as="フレームサイズ" v-validate="`'required'`" v-model="data.frameSize"/>
              </b-field>
            </td>
            <td></td>
          </tr>
          <tr>
            <th style="white-space:pre-wrap;width:250px;">マスク：固定方法<span class="require"/></th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('maskArea','fixingMethod')" class="change"></span></td>
            <td>
              <b-field :type="{'is-danger':errors.has('form4.form4_3char_fixingMethod')}" :message="errors.first('form4.form4_3char_fixingMethod')">
                <input disabled style="width:500px;" type="text" name="form4_3char_fixingMethod" data-vv-as="固定方法" v-validate="`'required'`" v-model="data.fixingMethod"/>
              </b-field>
            </td>
            <td></td>
          </tr>
          <tr>
            <th style="white-space:pre-wrap;">ロット番号</th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('maskArea','lot')" class="change"></span></td>
            <td>
              <input style="width:500px;" type="text" data-vv-as="ロット番号" maxlength="20" v-model="data.lot"/>
            </td>
          </tr>
          <tr v-if="data.maskType=='その他'">
            <th style="white-space:pre-wrap;width:250px;">備考</th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('maskArea','memo')" class="change"></span></td>
            <td>オーダー情報の備考欄を参照してください。</td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="!data.depositUseFlag&&!data.notDirections&&!isResume&&!isChangeValue">
        <span style="font-size:20px;">納品先情報</span>
        <br><span v-if="data.kind == cpapKindMap.applicationChange && innerUser">(直送オーダー/持出オーダーが発生する場合、ご確認ください。)</span>
        <table>
          <tr><th>機器納品先<span class="require"/></th><td>
            <div class="block">
              <b-radio class="td_radio" name="target"  v-model="data.delivaryTarget" native-value="home">患者宅</b-radio>
              <b-radio class="td_radio" name="target"  v-model="data.delivaryTarget" native-value="hospital">医療機関</b-radio>
            </div></td>
          </tr>
          <template v-if="data.delivaryTarget== 'hospital'">
            <!-- <tr><th>【機器納品先】</th></tr> -->
            <tr>
              <th>
                郵便番号<span class="require"/>
              </th>
              <td>
                <input
                  style="width: 250px;"
                  v-model="data.zip"
                  class="1"
                  :class="{'border-red': invalidPostcode}"
                  name="機器納品先の郵便番号"
                  validate="required|numeric"
                  maxlength="7"
                  :placeholder="postcodePlaceholder"
                />
                <b-button
                  style="margin-left: 10px; width: 150px; height: 27px;"
                  v-on:click="addressSearch(data.zip)">郵便番号検索
                </b-button>
                <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
              </td>
            </tr>
            <tr><th>住所<span class="require"/></th><td><input type="text" v-model="data.address" class="1" name="機器納品先の住所" validate="required" maxlength="280"/></td></tr>
            <tr><th>住所（丁目、番地）<span class="require"/></th><td><input type="text" v-model="data.address1" class="1" name="機器納品先の住所（丁目、番地）" validate="required" maxlength="256"/></td></tr>
            <tr><th>住所（建物名、号室）</th><td><input type="text" v-model="data.address2" maxlength="256"/></td></tr>
            <tr><th>納品先宛名<span class="require"/></th><td><input type="text" v-model="data.receiverName" maxlength="100" class="1" name="機器納品先の宛名" validate="required"/></td></tr>
            <tr>
              <th>
                連絡先(電話番号)<span class="require"/>
              </th>
              <td>
                <input
                  type="text"
                  v-model="data.phoneNumber"
                  maxlength="11"
                  class="1"
                  :class="{'border-red': invalidPhoneNumber}"
                  name="機器納品先の連絡先(電話番号)"
                  validate="required|numeric"
                  :placeholder="phonePlaceholder"
                />
                <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
              </td>
            </tr>
          </template>
          <template v-if="innerUser">
            <tr>
              <th style="vertical-align:top;">納品書コメント1</th>
              <td><textarea v-model="data.deliveryStatementComment1"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">納品書コメント2</th>
              <td><textarea v-model="data.deliveryStatementComment2"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">発送元<span class="require"/></th>
              <td>
                <div>
                <select v-model="data.senderType" class="2" name="発送元" validate="required" @input="selectSender" style="width:70%;">
                  <option value=""></option>
                  <option v-for="ship in cpapSenderMaster" :key="ship.code" :value="ship.code">{{ship.name}}</option>
                </select>
                <b-button v-if="innerUser" class="is-primary" style="margin-left:10px;height:30px;" @click="cpapStockModalActive=true">在庫検索</b-button>
                </div>
              </td>
            </tr>
              <!-- <template v-if="competitorsProduct()"> -->
              <tr>
                <th></th>
                  <td> 
                    <span style="color:red">※エスボックスバイスタルク、プリズマライン(prisma25S)の場合、発送元は支店を選択してください。</span>
                  </td> 
              </tr>
            <!-- </template> -->
            <template v-if="selectCagoEz()">
              <tr>
                <th></th>
                <td>            
                  <span style="color:red">※川越からEz-Start有りでは出荷できません。支店でしか対応できない為、変更してください</span>            
                </td> 
            　</tr>
            </template>
            <template v-if="isSendBranch()">
              <tr>
                <th style="vertical-align:top;">発送方法<span class="require"/></th>
                <td>
                  <select v-model="data.shippingMethod" class="2" name="発送方法" validate="required">
                    <option value=""></option>
                    <option v-for="ship in cpapShippingMethodList" :key="ship.code" :value="ship.code">{{ship.name}}</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>持出元営業所</th>
                <td style="vertical-align:center;">{{officeCode | codeToValueFilter(branchOfficeMaster)}}</td>
              </tr>
              <tr>
                <th>保管場所<span class="require"/></th>
                <td>
                  <select id="depositoryCode" class="2" name="保管場所" validate="required" v-model="data.depositoryCode">
                    <option value=""></option>
                    <option v-for="item in depositoryCodeMaster" :key="item.depositoryCode" :value="item.depositoryCode">{{item.depositoryName}}({{item.depositoryCode}})</option>
                  </select>
                  <span style="color:red">※他拠点を選択する場合は、事前に連絡して承諾を得てください。</span>
                </td>
              </tr>
            </template>
          </template>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && !isEscrow && isSendBranch() ">
      <!-- <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && isSendBranch && selectSender && selectCagoEz ()"> -->
         <!-- <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && isSendBranch && selectSender && selectCagoEz && competitorsProduct()"> -->
        <span style="font-size:20px;">配達情報</span>
        <table>
          <tr style="text-align:top;">
            <th style="vertical-align:top;">出荷日<span class="require"/></th>
            <td><input type="date" class="2" name="出荷日" validate="required" v-model="data.shippingDate" :min="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
          </tr>
        </table>
      </div>
      <!-- 
          <tr><th>配達指定日の有無<span class="require"/></th><td>
            <select v-model="data.isAppointedDelivery" class="2" name="配達指定日の有無" validate="required">
              <option value=""></option>
              <option value="0">配達指定日なし</option>
              <option value="1">配達指定日あり</option>
            </select>
          </td></tr>
          <tr v-if="data.isAppointedDelivery=='1'">
            <th style="vertical-align:top;">配達指定日<span class="require"/></th>
            <td><input type="date" class="2" name="配達指定日" validate="required" v-model="data.appointedDeliveryDate"/></td>
          </tr>
          <tr v-if="data.isAppointedDelivery=='1'">
            <th style="vertical-align:top;">配達時間帯<span class="require"/></th>
            <td>
              <select id="appointedDeliveryPeriodOfTime" name="配達時間帯" class="2" validate="required" v-model="data.appointedDeliveryPeriodOfTime">
                <option v-for="time in deliveryTimeZone" :value="time.value" :key="time.value">{{ time.text }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th style="vertical-align:top;">指定納期<span class="require"/></th>
            <td><input type="date" class="2" name="指定納期" validate="required" v-model="data.specifiedDeliveryDate"/></td>
          </tr>
      -->
      <!-- 処方変更(機種変更：返却がある場合) -->
      <div class="card-content margin-top printMargin printBreakInside" v-if="innerUser && (data.machineReturn || isSirialChange() || isReturnCheck())">
        <span style="font-size:20px;">返却情報</span>
        <table>
          <tr>
            <th>返却先<span class="require"/></th>
            <td>
              <div class="block">
                <b-radio class="td_radio" name="返却先" v-model="data.collectionDestination" :native-value="0"><span id="collectionDestination1">支店回収</span></b-radio>
                <b-radio class="td_radio" name="返却先" v-model="data.collectionDestination" :native-value="1"><span id="collectionDestination2">川越回収</span></b-radio>
              </div>
            </td>
          </tr>
          <!-- <tr> -->
          <tr v-if="innerUser">
            <th>契約終了日<span class="require"/></th>
            <td><input type="date" v-model="data.contractEndDate" :min="data.contractEndMin" style="width:150px;" class="1" name="契約終了日" validate="required|date" /></td>
          </tr>
          <!-- <tr> -->
          <tr v-if="innerUser">
            <th>当月請求<span class="require"/></th>
            <td>
              <select id="billingCurrentMonth" class="1" name="当月請求" validate="required" v-model="data.billingCurrentMonth">
                <option v-for="billed in billedCurrentMonth" :value="billed.value" :key="billed.value">{{ billed.text }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>中止理由<span class="require"/></th>
            <td>
              <select v-model="data.cancelReasonCode" class="1" name="中止理由" validate="required">
                <option></option>
                <option v-for="cancelCode in cancelCodeMaster" :value="cancelCode.value" :key="cancelCode.value">{{ cancelCode.text }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th style="vertical-align:top;">中止理由コメント</th>
            <td>
              <textarea maxlength="256" style="resize:vertical;max-width:100%;height:60px;" v-model="data.cancelReasonText"></textarea>
            </td>
          </tr>
        </table>
      </div>
      <div class="card-content margin-top">
        <span style="font-size:20px;">オーダー情報</span>
        <table>
          <template v-if="innerUser">
            <tr>
              <th style="vertical-align:top;">請求開始日<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('orderArea','billingStartDate')" class="change"></span></td>
              <td><input type="date" class="2" name="請求開始日" validate="required" v-model="data.billingStartDate" :min="data.billingStartMin"/></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">請求書コメント</th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('orderArea','billComment')" class="change"></span></td>
              <td><textarea v-model="data.billComment"></textarea></td>
            </tr>
            <tr>
              <!-- Webシステム -->
              <th style="vertical-align:top;">診療科コード<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('orderArea','departmentCode')" class="change"></span></td>
              <td><select id="departmentCode" class="2" name="診療科コード" validate="required" v-model="data.departmentCode">
                <option v-for="department in departmentMaster" :value="department.value" :key="department.value">{{ department.text }}（{{department.value}}）</option>
              </select></td>
            </tr>
            <tr>
              <!-- Webシステム -->
              <th style="vertical-align:top;">得意先区分<span class="require"/></th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('orderArea','customerClass')" class="change"></span></td>
              <td><select id="customerClass" class="2" name="得意先区分" validate="required" v-model="data.customerClass">
                <option v-for="customer in customerCategory" :value="customer.value" :key="customer.value">{{ customer.text }}</option>
              </select></td>
            </tr>
            <tr v-if="innerUser && resume">
              <th style="vertical-align:top;">前回消耗品供給日<span class="require"/></th>
              <td><span></span></td>
              <td><input type="date" class="2" name="前回消耗品供給日" validate="required" v-model="data.accessoryLastSupplyDate" /></td>
            </tr>            
            <tr v-if="!isChangeValue && (data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval)">
              <th style="vertical-align:top;">直送先種別</th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('orderArea','directShippingType')" class="change"></span></td>
              <td><select id="directShippingType" v-model="data.directShippingType">
                <option value=""></option>
                <option v-for="directShipping in cpapDirectShippingList" :value="directShipping.code" :key="directShipping.code">{{ directShipping.name }}</option>
              </select></td>
            </tr>
            <tr v-if="!isChangeValue && (data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval)">
              <th style="vertical-align:top;">リースアップ種別</th>
              <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('orderArea','leaseUpType')" class="change"></span></td>
              <td><select id="leaseUpType" v-model="data.leaseUpType">
                <option value=""></option>
                <option v-for="leaseUp in cpapLeaseUpList" :value="leaseUp.code" :key="leaseUp.code">{{ leaseUp.name }}</option>
              </select></td>
            </tr>
            <tr v-if="!isChangeValue && (data.kind == cpapKindMap.application || data.kind == cpapKindMap.applicationResume || data.kind == cpapKindMap.applicationTempRemoval)">
              <th></th>
              <td></td>
              <td>
                <span style="color:red">直送先種別とリースアップ種別は、空欄の場合は患者宅に配送されます。</span>
              </td>
            </tr>
            <!-- webシステムより不要との回答あり
            <tr>
              <th style="vertical-align:top;">戦略施策<span class="require"/></th>
              <select id="strategicMeasures" class="2" name="戦略施策" validate="required" v-model="data.strategicMeasures">
                <option v-for="strategic in strategicMeasures" :value="strategic.value" :key="strategic.value">{{ strategic.text }}</option>
              </select>
            </tr>
            <tr>
              <th style="vertical-align:top;">戦略施策コメント</th>
              <td><textarea v-model="data.strategicMeasuresComment"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">予備<span class="require"/></th>
              <select id="reserve" name="予備" class="2" validate="required" v-model="data.reserve">
                <option v-for="res in reserve" :value="res.value" :key="res.value">{{ res.text }}</option>
              </select>
            </tr>
            <tr>
              <th style="vertical-align:top;">予備コメント</th>
              <td><textarea v-model="data.reserveComment"></textarea></td>
            </tr> -->
          </template>
          <tr>
            <th style="vertical-align:top;">備考</th>
            <td id="editMark"><span v-if="(data.kind==cpapKindMap.applicationChange || data.kind==cpapKindMap.applicationResume) && singleChangedCheck('orderArea','memo')" class="change"></span></td>
            <td>
              <textarea maxlength="256" style="resize:vertical;max-width:100%;height:120px" v-model="data.memo"></textarea>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <b-modal :active.sync="quotationModalActive" has-modal-card full-screen>
      <quotationSelectModal :hospital="data.medicalInstitutionCode" :selectItemModel="data.model" title="見積選択" labelForOrg="品目名称" topMsg="既に見積選択済みの場合は、情報が上書きされますのでご注意ください。" :belongs="data.belongsId" :institutionId="data.institutionId" @select="setQuotation" :showDetailTargetData="data" :directionsItems="directionsItemList" :resume="isResume"></quotationSelectModal>
    </b-modal>
    <!-- 見積一括選択 -->
    <b-modal :active.sync="bulkQuotationModalActive" has-modal-card full-screen>
      <quotationBulkSelectModal :hospital="data.medicalInstitutionCode" :selectItemModel="data.model" title="見積一括選択" labelForOrg="品目名称" topMsg="既に見積選択済みの場合は、情報が上書きされますのでご注意ください。" :belongs="data.belongsId" :institutionId="data.institutionId" @select="setQuotationBulk" :showDetailTargetData="data" :directionsItems="directionsItemList" :resume="isResume"></quotationBulkSelectModal>
    </b-modal>
    <!-- 品目単位の見積選択 -->
    <b-modal :active.sync="itemQuotationModalActive" has-modal-card full-screen>
      <quotationSelectModal :hospital="data.medicalInstitutionCode" :selectItemModel="data.model" title="品目見積選択" labelForOrg="品目名称" :topMsg="'対象品目コード：'+quotationItemCode" :belongs="data.belongsId" :institutionId="data.institutionId" @select="setQuotationItem" :showDetailTargetData="data" :directionsItems="directionsItemList" :resume="isResume"></quotationSelectModal>
    </b-modal>
    <b-modal :active.sync="cpapOrderSelectModalActive" has-modal-card full-screen>
      <cpapOrderSelectModal title="預託オーダー選択" @select="setDepositUseOrder" :id="searchDepositUseOrderId" :item="searchOrderItemCode" :serialNumber="searchOrderSerialNumber" :order="data.orderType" :orderTypeList="orderProcessType" :salesOffice="data.branchOffice" :salesperson="data.salesStaffCode" :billingDestination="!data.dealerFollowFlg ? data.billingCode : ''" :hospital="data.medicalInstitutionCode"></cpapOrderSelectModal>
    </b-modal>
    <b-modal :active.sync="patientModalActive" has-modal-card>
      <patientSelectModal title="患者選択" :selectPatientName="data.patient.patientFamilyName+' '+data.patient.patientFirstName" :selectHospitalName="data.hospitalName" @select="setPatient"></patientSelectModal>
    </b-modal>
    <b-modal :active.sync="maskSelectModalActive" has-modal-card full-screen>
      <cpapMaskSelectModal :formatType="formatType" @select="maskSelect"></cpapMaskSelectModal>
    </b-modal>
    <b-modal :active.sync="cpapStockModalActive" has-modal-card full-screen>
      <cpapStockModal :targetOffice="'J'+officeCode" :belongsId="data.belongsId"></cpapStockModal>
    </b-modal>
    <b-modal :active.sync="tempDeviceSelectModalActive" has-modal-card>
      <!-- <instrumentSelectModal @select="tempDeviceSelect" :selectItemCode="searchItemCode" :searchType="targetType" :selectModel="searchModel" :selectSerial="searchSerial"></instrumentSelectModal> -->
      <instrumentSelectModal @select="tempDeviceSelect" :selectItemCode="searchItemCode" :searchType="targetType" :selectModel="searchModel" :selectSerial="searchSerial" :belongsId="data.belongsId"></instrumentSelectModal>
    </b-modal>
    <!-- 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より） -->
    <b-modal :active.sync="escrowDeviceSelectModalActive" has-modal-card>
      <EscrowInstrumentSelectModal @select="tempDeviceSelect" :selectItemCode="searchItemCode" :searchType="targetType" :selectModel="searchModel" :selectSerial="searchSerial"></EscrowInstrumentSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {
  cpapPatientRegisterStatus,
  cpapShippingMethodList,
  cpapSenderMaster,
  cpapKindMap,
  cpapDirectShippingList,
  cpapLeaseUpList,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  cpapRequestStatus,
  prescriptionHardwareList, // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
} from "@/components/mock/base/const.js";
import QuotationSelectModal from "@/components/mock/philips/common/QuotationSelectModal";
import QuotationBulkSelectModal from "@/components/mock/philips/common/QuotationBulkSelectModal";
import CpapOrderSelectModal from "@/components/mock/philips/common/CpapOrderSelectModal";
import PatientSelectModal from "@/components/mock/philips/common/PatientSelectModal";
import CpapMaskSelectModal from "@/components/mock/philips/common/CpapMaskSelectModal";
import CpapStockModal from "@/components/mock/philips/common/CpapStockModal";
import InstrumentSelectModal from "@/components/mock/philips/common/InstrumentSelectModal";
import EscrowInstrumentSelectModal from "@/components/mock/philips/common/EscrowInstrumentSelectModal"; // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）

export default {
  name: "CpapRequestDetailEdit",
  props: ["data","innerUser","isUser","changeValue","temp","resume","comment"],
  // props: ["data","innerUser","changeValue","temp","resume"],
  methods: {
    isHideItem: function(displayName) {
      if(displayName == "登録方法"){
        var patientManagement = this.data.prescriptionItems.find(val => val.displayName == "患者情報管理")
        if(patientManagement && patientManagement.value=='0'){
          return true
        }
      }
      if(displayName == "E-mailアドレス"){
        var mobileApply = this.data.prescriptionItems.find(val => val.displayName == "モバイルアプリ")
        if(mobileApply && mobileApply.value=='0'){
          return true
        }
      }
      return false
    },
    tempDeviceSelect: async function(deviceInfo){
      var machineChange = false
      // 品目情報の機器選択ボタン押下時
      if(this.tempDeviceSelectFlag){
        // 品目コードと一致しない機器は紐づけしない
        if(this.searchModel != ""){
          if(this.searchModel != deviceInfo.itemCode){
            this.targetType = ""
            this.searchModel = ""
            this.searchItemCode = ""
            this.searchSerial = ""
            return
          } 
        }
        if(this.searchItemCode != ""){
          if(this.searchItemCode != deviceInfo.itemCode){
            this.targetType = ""
            this.searchModel = ""
            this.searchItemCode = ""
            this.searchSerial = ""
            return
          } 
        }
      }
      if(this.targetType==0){
        // CPAP機器
        this.data.tempDeviceId = deviceInfo.id
        this.data.model = deviceInfo.itemCode
        this.data.serial = deviceInfo.serial
        machineChange = true
      }else if(this.targetType==1){
        // 加湿器
        this.data.moistItemCode = deviceInfo.itemCode
        this.data.moistSerial = deviceInfo.serial
      }else if(this.targetType==2){
        // 通信モジュール
        this.data.moduleItemCode = deviceInfo.itemCode
        this.data.moduleSerial = deviceInfo.serial
      }
      // 3：マスク
      // 4：呼吸回路

      this.data.provisionalTakenOutItems = this.data.provisionalTakenOutItems.filter(val => {
        return val.itemCode!=deviceInfo.itemCode
      })
      this.data.provisionalTakenOutItems.push(deviceInfo)
      this.targetType = ""
      this.searchModel = ""
      this.searchItemCode = ""
      this.searchSerial = ""
      if(this.modelChangeFlg){
        var model = this.modelList.find(item => item.itemCodes && item.itemCodes.indexOf(deviceInfo.itemCode) != -1)
        if(model){
          var modelItem = model.items.find(item => item.itemCode == deviceInfo.itemCode)
          this.data.model = modelItem.itemCode
          this.data.reportFormatType = model.reportFormatType
        }
        await this.changeModel()
        this.modelChangeFlg = false
      }
      this.getDirectionsItemList()
    },
    tempDeviceModalOn: function(code, serial) {
      var target = this.cpapAccessories.find(val => val.itemCode == code)
      this.targetType = target.itemType
      this.searchModel =  target.itemType==0 ? code : ""
      this.searchItemCode = target.itemType!=0 ? code : ""
      this.searchSerial = serial
      this.tempDeviceSelectFlag = true
      this.tempDeviceSelectModalActive = true
    },
    tempDeviceChange: function(type, flg){
      this.targetType = type
      this.modelChangeFlg = flg
      this.tempDeviceSelectFlag = false
      this.tempDeviceSelectModalActive = true
    },
    // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
    escrowDeviceChange: function(type, flg){
      this.targetType = type
      this.modelChangeFlg = flg
      this.escrowDeviceSelectModalActive = true
    },
    getMachineName: function() {
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      return model ? model.itemName + "(" + this.data.model + ")" : ""
    },
    selectSender: function() {
      if(!this.data.senderType) return false
      var target = this.cpapSenderMaster.find(val => val.code == this.data.senderType)
      if(!target || target.name.indexOf("川越") != -1){
        this.data.shippingMethod = "1"
      }
    },
    isSendBranch: function() {
      if(!this.data.senderType) return false
      var target = this.cpapSenderMaster.find(val => val.code == this.data.senderType)
      if(target && target.name.indexOf("支店") != -1){
        // 支店発送の場合
        // 出荷日の表示は支店回覧のみ
        if (this.data.status == cpapRequestStatus.completion) {
          return false
        } else {
          return true
        }
      }
      return false
    },
    //ezStart有の場合
    selectCagoEz: function() {
      if(!this.data.senderType) return false
      var ezStart = this.data.prescriptionItems.find(val => val.displayName == 'Ez-Start')
      var target = this.cpapSenderMaster.find(val => val.code == this.data.senderType)
      if(!ezStart){
        return false
      }
        if(ezStart.value == 1 && (target.name == "川越") ){
          //ezStart有 && 川越出荷
          return true
        
        }else{
      
        return false
        }
    },
    // シリアル交換チェック
    isSirialChange: function() {
      if(!this.innerUser) return false
      for(var directions of this.directionsItemList ){
        if(directions.shippingInstructionsFlg && directions.collectionInstructionsFlg){
          return true
        }
      }
      return false
    },
    // 支店回覧時、返却物チェック
    isReturnCheck: function() {
      if(!this.innerUser) return false
      for(var directions of this.directionsItemList ){
        if(directions.collectionInstructionsFlg){
          return true
        }
      }
      if(!this.data.machineReturn){
        this.data.collectionDestination = ""
        this.data.contractEndDate = ""
        this.data.billingCurrentMonth = ""
        this.data.cancelReasonCode = ""
        this.data.cancelReasonText = ""
      }
      return false
    },
    // エスボックス/プリズマライン(prisma25S)の場合
    competitorsProduct: function() {
      if(!this.data.senderType) return false
      var target = this.cpapSenderMaster.find(val => val.code == this.data.senderType)
      //エスボックス/プリズマライン(prisma25S)　&&川越出荷の場合
      if(this.data.reportFormatType == '5' || this.data.reportFormatType == '6' && (target.name == "川越")){
          return true
      }else{
          return false
      }
    },
    setQuotation: function(quotationInfo) {
      this.data.estimateCode = quotationInfo.quotationNumber
      this.data.estimateDetailCode = quotationInfo.items
      this.data.moistItemCode = ""
      this.data.moduleItemCode = ""
      // 見積番号に含まれている加湿器/通信モジュールの品目コードをセット
      for(let item of this.data.estimateDetailCode){
        item.estimateCode = quotationInfo.quotationNumber
        var target = this.cpapAccessories.find(val => val.itemCode == item.itemCode)
        if(target){
          switch(target.type){
            case "cpap":
              // 見積詳細でCPAPが選択されている場合
              this.data.model = item.itemCode
              break;
            case "moist":
              // 見積詳細で加湿器が選択されている場合
              this.data.moistItemCode = item.itemCode
              break;
            case "module":
              // 見積詳細で通信モジュールが選択されている場合
              this.data.moduleItemCode = item.itemCode
              break;
          }
        }
      }
      this.getDirectionsItemList();
    },
    setQuotationBulk: function(quotationInfo) {
      // 見積情報上書き
      if(this.data.estimateDetailCode && this.data.estimateDetailCode.length > 0){
        for(let target of quotationInfo.items){
          var updateTarget = this.data.estimateDetailCode.find(val => val.itemCode == target.itemCode)
          if(updateTarget){
            updateTarget.itemCode = target.itemCode ? target.itemCode:"",
            updateTarget.itemName = target.itemName ? target.itemName:"",
            updateTarget.quotationDetailsNumber = target.quotationDetailsNumber ? target.quotationDetailsNumber:"",
            updateTarget.quantity = target.quantity ? target.quantity:"",
            updateTarget.unit = target.unit ? target.unit:"",
            updateTarget.deliveryPrice = target.deliveryPrice ? target.deliveryPrice:"",
            updateTarget.unitPrice = target.unitPrice ? target.unitPrice:"",
            updateTarget.quotationPrice = target.quotationPrice ? target.quotationPrice:"",
            updateTarget.comment = target.comment ? target.comment:"",
            updateTarget.latestOrderRegisteredDate = target.latestOrderRegisteredDate ? target.latestOrderRegisteredDate:"",
            updateTarget.estimateCode = target.estimateCode ? target.estimateCode:"",
            updateTarget.billingDestinationCode = target.billingDestinationCode ? target.billingDestinationCode:"",
            updateTarget.hospitalCode = target.hospitalCode ? target.hospitalCode:""
          }else{
            this.data.estimateDetailCode.push(target)
          }
        }
      }else{
        this.data.estimateDetailCode = quotationInfo.items
      }
      this.data.moistItemCode = ""
      this.data.moduleItemCode = ""
      // 見積番号に含まれている加湿器/通信モジュールの品目コードをセット
      for(let item of this.data.estimateDetailCode){
        if(!item.estimateCode) item.estimateCode = quotationInfo.quotationNumber
        var target = this.cpapAccessories.find(val => val.itemCode == item.itemCode)
        if(target){
          switch(target.type){
            case "cpap":
              // 見積詳細でCPAPが選択されている場合
              this.data.model = item.itemCode
              this.data.estimateCode = item.estimateCode
              break;
            case "moist":
              // 見積詳細で加湿器が選択されている場合
              this.data.moistItemCode = item.itemCode
              break;
            case "module":
              // 見積詳細で通信モジュールが選択されている場合
              this.data.moduleItemCode = item.itemCode
              break;
          }
        }
      }
      this.getDirectionsItemList();
    },
    setDepositUseOrder: function(order) {
      let orderItem = order.items.find(val => val.itemCode==this.searchOrderItemCode)
      if(!orderItem || orderItem.length < 1) return
      var target = this.cpapAccessories.find(val => val.itemCode == this.searchOrderItemCode)
      if(target){
        switch(target.type){
          case "cpap":
            this.data.serial = orderItem ? orderItem.serial : ""
            this.data.depositUseOrderId = order.orderId
            break;
          case "moist":
            this.data.moistSerial = orderItem ? orderItem.serial : ""
            this.data.depositUseMoistId = order.orderId
            break;
          case "module":
            this.data.moduleSerial = orderItem ? orderItem.serial : ""
            this.data.depositUseModuleId = order.orderId
            break;
        }
      }
      order.items = [orderItem]
      if(this.data.depositUseOrderDetail){
        this.data.depositUseOrderDetail = this.data.depositUseOrderDetail.filter(val => val.items[0].itemCode != this.searchOrderItemCode)
      }else{
        this.data.depositUseOrderDetail = []
      }
      this.data.depositUseOrderDetail.push(order)
      this.searchDepositUseOrderId = ""
      this.searchOrderItemCode = ""
      this.searchOrderSerialNumber = ""
      this.getDirectionsItemList()
    },
    setPatient: function(patientInfo) {
      this.data.patientCode = patientInfo.patientCode
    },
    inputBirthday: function(birthday){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.data.patient.age = age < 0 ? 0 : age
        const date = new Date(birthday);
        const options = {era: 'long'};
        this.data.patient.japaneseCalendar = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.data.patient.age = ""
      }
    },
    changeModel: async function() {
      // 処方値の取得
      this.changeBeforeUseModule = this.data.useModule
      var moduleDate = this.data.prescriptionItems.find(val => val.category==2 && val.type=="calender")
      this.beforeModuleDate = moduleDate && moduleDate.value ? moduleDate.value : ""

      this.changeBeforeUseMoist = this.data.useMoist
      var moistDate = this.data.prescriptionItems.find(val => val.category==1 && val.type=="calender")
      this.beforeMoistDate = moistDate && moistDate.value ? moistDate.value : ""

      var moistMode = this.data.prescriptionItems.find(val => val.category==1 && val.displayName == "加湿モード")
      this.beforeMoistMode = moistMode && moistMode.value ? moistMode.value : ""
 
      var moistSet = this.data.prescriptionItems.find(val => val.category==1 && val.displayName == "加湿器設定")
      this.beforeMoistSet = moistSet && moistSet.value ? moistSet.value : ""
      
      var moistK = this.data.prescriptionItems.find(val => val.category==1 && val.displayName == "回路温度設定")
      this.beforeMoistK = moistK && moistK.value ? moistK.value : ""

      var moduleP = this.data.prescriptionItems.find(val => val.category==2 && val.displayName == "患者情報管理")
      this.beforeModuleP = moduleP && moduleP.value ? moduleP.value : ""
      
      var moduleT = this.data.prescriptionItems.find(val => val.category==2 && val.displayName == "登録方法")
      this.beforeModuleT = moduleT && moduleT.value ? moduleT.value : ""

      this.changeBeforeUseModuleSerial = this.data.moduleSerial
      this.changeBeforeUseMoistSerial = this.data.moistSerial
      this.changeBeforeUseModuleItemCode = this.data.moduleItemCode
      
      this.data.useMoist = false
      this.data.useModule = false
      if (this.isEscrow || this.modelChangeFlg){
        // 変更後機種がGo,プリズマの場合モデムシリアル初期化
        if(this.data.reportFormatType == "3" || this.data.reportFormatType == "6"){
          this.data.moduleSerial = ""
        }
      }
      if(!this.data.reportFormatType){
        return
      }
      this.data.prescriptionItems = []
      var excuteApi = this.getPrescriptionValueItemsPOST;
      var successCallBack = this.getPrescriptionValueItemsPOSTSuccess;
      var errorCallBack = this.getPrescriptionValueItemsPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPrescriptionValueItemsPOST: function(client) {
      return client.apis.externalCpap.getPrescriptionValueItemsPOST({
        body:{
          formatType:this.data.reportFormatType
        }
      });
    },
    getPrescriptionValueItemsPOSTSuccess: function(result) {
      this.data.prescriptionItems = result.obj
      this.data.useMoist = true
      this.data.useModule = true
      this.moduleList = ""
      this.data.moduleItemCode = ""
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)

      if(model){
        var setItem = this.cpapSetItems.find(val => val.cpapItemCode == model.itemCode)
        if(setItem.module){
          this.moduleList = setItem.module
        }
        //QA73_仮持出→処方変更時に本体を変更時モデム無しに切り替わる
        if(setItem.moduleItemCode){
          // this.moduleList = ""
          this.data.moduleItemCode = setItem.moduleItemCode
        }
      }
      
      for(var i=0; i<this.data.prescriptionItems.length; i++){
        var item = this.data.prescriptionItems[i]
        if(item.displayName == "モード" && item.defaultValue){
          this.data.mode = item.defaultValue
          continue
        }

        //TODO 20230818 処方変更（仮持出含む）本体変更時に加湿器モデムの情報が消える
        // if(item.type=="radio" && item.value=="0"){
        //   if(item.category==1) this.data.useMoist = false
        //   if(item.category==2) this.data.useModule = false
        // }else if(item.category==2 && model.reportFormatType!=3 && model.reportFormatType!=6){

        // 通信モジュール
        if(item.category==2){
          //QA73_仮持出→処方変更時に本体を変更時モデム無しに切り替わる
          if((item.type=="radio" || item.type=="sel") && item.value=="0"){
            item.value = "0"
            this.data.useModule = false           
            continue
          //QA73_仮持出→処方変更時に本体を変更時モデム無しに切り替わる
          }else if((item.type=="radio" || item.type=="sel")  && item.value=="1"){
            // 通信モジュールの関連項目の場合(Prisma)
            if(model.reportFormatType==6){
              item.value = "0"
              this.data.useModule = false           
              continue

            // 通信モジュールの関連項目の場合(DSgo)
            }else if(model.reportFormatType==3 ){
              if(item.displayName == "モバイルアプリ" && this.changeBeforeUseModule){
                item.value = this.beforeModuleP
                continue
              }
              if(item.displayName == "患者情報管理" && this.changeBeforeUseModule){
                item.value = this.beforeModuleP
                continue
              }

            // 通信モジュールの関連項目の場合(S-BOX)
            }else if(model.reportFormatType==5){
              if(item.type=="radio" && !this.changeBeforeUseModule){
              // 処方変更前が無しだった場合、引き継ぐ
                item.value = "0"
                this.data.useModule = false
                continue
              }
              if(item.displayName == "患者情報管理" && this.changeBeforeUseModule){
                if(this.beforeModuleP !=0){
                  item.value = ""
                  continue
                }else{
                  item.value = this.beforeModuleP
                  continue
                }
              }
              if(item.displayName == "登録方法" && this.changeBeforeUseModule){
                item.value = this.beforeModuleT
                continue
              }
            
            // 通信モジュールの関連項目の場合(DSgo以外)
            }else if(model.reportFormatType!=3 && model.reportFormatType!=5 && model.reportFormatType!=6){
              if(item.type=="radio" && !this.changeBeforeUseModule){
              // 処方変更前が無しだった場合、引き継ぐ
                item.value = "0"
                this.data.useModule = false
                continue
              }
              if(item.displayName == "患者情報管理" && this.changeBeforeUseModule){
                item.value = this.beforeModuleP
                continue
              }
              if(item.displayName == "登録方法" && this.changeBeforeUseModule){
                item.value = this.beforeModuleT
                continue
              }
            }
          }
          //QA73_仮持出→処方変更時に本体を変更時モデム無しに切り替わる
          if(item.type=="calender" && this.changeBeforeUseModule && this.beforeModuleDate){
              // 処方変更前が有りだった場合、設置日を引き継ぐ
                item.value = this.beforeModuleDate
                continue
          }          
        }
        // 加湿器の関連項目の場合
        if(item.category==1){

          if(item.type=="radio" && !this.changeBeforeUseMoist){
            // 処方変更前が無しだった場合、引き継ぐ
            item.value = "0"
            this.data.useMoist = false
            continue
          } else if(item.type=="radio" && this.changeBeforeUseMoist){
            // 処方変更前がありだった場合、引き継ぐ
            item.value = "1"
            this.data.useMoist = true
            continue
          }
          if(item.type=="calender" && this.changeBeforeUseMoist && this.beforeMoistDate){

            // 処方変更前が有りだった場合、設置日を引き継ぐ
            item.value = this.beforeMoistDate
          }
          if(item.displayName == "加湿モード" && this.changeBeforeUseMoist){
            item.value = this.beforeMoistMode
            continue
          }
          if(item.displayName == "加湿器設定" && this.changeBeforeUseMoist){
            item.value = this.beforeMoistSet
            continue
          }
          // 回路温度設定
          var circuit = this.data.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
          if(circuit){          
            if(this.beforeMoistMode=="0" || this.beforeMoistMode=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
          }
        }
        this.changeSelect(item.displayName,item.value,item.itemName)
      }
      if(this.isChangeValue){
        // 機種変更の場合、シリアルと見積もり情報の初期化
        if(!this.temp) this.data.serial = ""
        // this.data.estimateCode = ""
        // this.data.estimateDetailCode = []

        // 加湿器モデムの情報の引継ぎ
        // シリアル
        if(this.changeBeforeUseModule) this.data.moduleSerial = this.changeBeforeUseModuleSerial;
        if(this.changeBeforeUseMoist) this.data.moistSerial = this.changeBeforeUseMoistSerial;

        // itemCodeからitemName取得
        if(this.changeBeforeUseModule) this.data.moduleItemCode = this.changeBeforeUseModuleItemCode;

      }
      this.getDirectionsItemList()
      if(model){
        this.controlDirectionsItem(model.itemCode,"cpap")
        var setItem = this.cpapSetItems.find(val => val.cpapItemCode == model.itemCode)
        if(this.data.useMoist && setItem.moistItemCode){
          // 加湿器
          this.controlDirectionsItem(setItem.moistItemCode,"moist")
        }
      }
    },
    getPrescriptionValueItemsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back();
    },
    gatDepartmentCode: async function() {
      // 診療科コードリスト取得
      var excuteApi = this.getCpapDepartmentCodeListPOST;
      var successCallBack = this.getCpapDepartmentCodeListPOSTSuccess;
      var errorCallBack = this.getCpapDepartmentCodeListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapDepartmentCodeListPOST: function(client) {
      return client.apis.apiCommon.getCpapDepartmentCodeListPOST({
        body:{}
      });
    },
    getCpapDepartmentCodeListPOSTSuccess: function(result) {
      this.departmentMaster = result.obj
    },
    getCpapDepartmentCodeListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.webHtApiErr = true
      this.back();
    },
    gatCodeMasterList: async function() {
      // CPAP汎用コードマスタリストの取得
      var excuteApi = this.getCpapCodeMasterListPOST;
      var successCallBack = this.getCpapCodeMasterListPOSTSuccess;
      var errorCallBack = this.getCpapCodeMasterListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapCodeMasterListPOST: function(client) {
      return client.apis.apiCommon.getCpapCodeMasterListPOST({
        body:[
          this.cpapCodeMaster.orderProcessType,
          this.cpapCodeMaster.rentalType,
          this.cpapCodeMaster.customerCategory,
          // 戦略施策(不要)
          // this.cpapCodeMaster.strategicMeasures,
          // 予備(不要)
          // this.cpapCodeMaster.reserve,
          this.cpapCodeMaster.deliveryTimeZone,
          // 預託機
          this.cpapCodeMaster.billedCurrentMonth,
          this.cpapCodeMaster.cancellReason
        ]
      });
    },
    getCpapCodeMasterListPOSTSuccess: function(result) {
      this.orderProcessType = result.obj[this.cpapCodeMaster.orderProcessType]
      this.rentalType = result.obj[this.cpapCodeMaster.rentalType]
      this.customerCategory = result.obj[this.cpapCodeMaster.customerCategory]
      // 戦略施策(不要)
      // this.strategicMeasures = result.obj[this.cpapCodeMaster.strategicMeasures]
      // 予備(不要)
      // this.reserve = result.obj[this.cpapCodeMaster.reserve]
      this.deliveryTimeZone = result.obj[this.cpapCodeMaster.deliveryTimeZone]
      // 預託機
      this.billedCurrentMonth = result.obj[this.cpapCodeMaster.billedCurrentMonth]
      this.cancelCodeMaster = result.obj[this.cpapCodeMaster.cancellReason]
    },
    getCpapCodeMasterListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.webHtApiErr = true
      this.back();
    },
    inputRadioValue: function(result,name){
      switch(name){
        case "useMoist":
          // var moistDate = this.data.prescriptionItems.find(val => val.category==1 && val.type=="calender")
          this.data.useMoist = result=="1"
          if (this.isEscrow) {
            // 預託の場合、有→無に変更した際に品目コードを削除（支店回覧時の回収指示がチェックされないため）
            this.data.moistItemCode = ""
          }
          this.getDirectionsItemList()
          break;
        case "useModule":
          this.data.useModule = result=="1"
          this.data.moduleItemCode = ""
          var moduleDate = this.data.prescriptionItems.find(val => val.category==2 && val.type=="calender")
          if(!moduleDate.value) moduleDate.value = this.yyyy_hyp_MM_hyp_dd(new Date())
          this.getDirectionsItemList()
          break;
      }
    },
    focusLostPatientFirstName: function(index) {
      if(!this.data.patient.receiverName || this.data.patient.receiverName==""){
        this.data.patient.receiverName = this.data.patient.patientFamilyName + " " + this.data.patient.patientFirstName
      }
    },
    patientAddressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.data.patient.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.data.patient.address1 = ""
        this.data.patient.address2 = ""
      })
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        this.data.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.data.address1 = ""
        this.data.address2 = ""
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },
    getMode: function(){
      return this.data.mode
    },
    changeSelect: function(name, value,sapName) {
      if(name == "モード"){
        this.data.mode = value
        return
      }
      var model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType)
      switch(model.reportFormatType){
        case 1:
          // ドリームステーションAuto
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.data.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 2:
          // ドリームステーションPro
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.data.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 3:
          // ドリームステーションGo
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.data.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 4:
          // ドリームステーションBiPAP Auto
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionItems.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "ライズタイム"
            var riseTime = this.data.prescriptionItems.find(val => val.displayName == "ライズタイム" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "ライズタイムロック"
            var riseTimeLock = this.data.prescriptionItems.find(val => val.displayName == "ライズタイムロック" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
              riseTime.value = riseTime.defaultValue
              riseTimeLock.value = riseTimeLock.defaultValue
              riseTime.disabled = false
              riseTimeLock.disabled = false
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
              riseTime.value = ""
              riseTimeLock.value = ""
              riseTime.disabled = true
              riseTimeLock.disabled = true
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionItems.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.data.prescriptionItems.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 5:
          // エスボックス バイスタルク
          if(name == "CC+"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.data.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.data.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              ccAll.value = ""
              ccLamp.value = ""
              ccAll.disabled = true
              ccLamp.disabled = true
            }else{
              ccAll.value = ""
              ccAll.disabled = true
              ccLamp.value = ccLamp.defaultValue
              ccLamp.disabled = false
            }
            return
          }
          if(name == "CC+機能有効時間　全治療時間"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.data.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.data.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value!="" && value!=null && value!="null"){
              // "CC+機能有効時間　ランプのみ"　非活性
              ccLamp.value = ""
              ccLamp.disabled = true
            }else{
              ccLamp.value = ccLamp.defaultValue
              ccLamp.disabled = false
              ccAll.disabled = true
            }
            return
          }
          if(name == "CC+機能有効時間　ランプのみ"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.data.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.data.prescriptionItems.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value!="" && value!=null && value!="null"){
              ccAll.value = ""
              ccAll.disabled = true
            }else{
              ccAll.value = ccAll.defaultValue
              ccAll.disabled = false
              ccLamp.disabled = true
            }
            return
          }
          if(name == "ランプ機能"){
            // "ランプタイム"
            var lampTime = this.data.prescriptionItems.find(val => val.displayName == "ランプタイム" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "ランプ時間【分】"
            var lampTimeMinutes = this.data.prescriptionItems.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "ランプ開始圧【hPa(cmH2O)】"
            var lampStart = this.data.prescriptionItems.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampTime.value = ""
              lampTimeMinutes.value = ""
              lampStart.value = ""
              lampTime.disabled = true
              lampTimeMinutes.disabled = true
              lampStart.disabled = true
            }else{
              lampTime.value = lampTime.defaultValue
              lampTimeMinutes.value = lampTimeMinutes.defaultValue
              lampStart.value = lampStart.defaultValue
              lampTime.disabled = false
              lampTimeMinutes.disabled = false
              lampStart.disabled = false
            }
            return
          }
          if(name == "ランプタイム"){
            // "ランプ時間【分】"
            var lampTimeMinutes = this.data.prescriptionItems.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="1"){
              lampTimeMinutes.value = ""
              lampTimeMinutes.disabled = true
            }else{
              // ランプ機能
              var lamp = this.data.prescriptionItems.find(val => val.displayName == "ランプ機能" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
              if(lamp.value!="0"){
                lampTimeMinutes.value = lampTimeMinutes.defaultValue
                lampTimeMinutes.disabled = false
              }
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionItems.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          break;
        case 6:
          // プリズマ ライン (prisma25S)
          break;
      }
      if(sapName=="KOKTY"){
        // 回路変更前の品目コード
        let deleteCircuitItemCode = ""
        let changedCircuitItemCode = ""
        if(this.data.circuitItemCode) deleteCircuitItemCode = this.data.circuitItemCode.split('_')
        // 回路入力時
        this.getDirectionsItemList()
        if(this.data.circuitItemCode) changedCircuitItemCode = this.data.circuitItemCode.split('_')
        if(changedCircuitItemCode != ""){
          for(let i =1 ; i < changedCircuitItemCode.length; i++){
            for(let directionsItem of this.directionsItemList){
              if(directionsItem.itemCode == changedCircuitItemCode[i]){
                // 変更後の出荷指示フラグ=true
                directionsItem.shippingInstructionsFlg = true
              }
            }
          }
        }
        if(deleteCircuitItemCode != ""){
          for(let i =1 ; i < deleteCircuitItemCode.length; i++){
            // 旧回路の見積を削除
            let deleteDirection = this.directionsItemList.filter(val => val.itemCode == deleteCircuitItemCode[i])
            this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => val.itemCode != deleteCircuitItemCode[i])
            if(deleteDirection.length > 0){
              deleteDirection[0].estimateCode= ""
              deleteDirection[0].quotationDetailsNumber= ""
              deleteDirection[0].shippingInstructionsFlg = false
            }
          }
        }
      }
    },
    getMaskMaster: function() {
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      if(model){
        this.formatType = model.reportFormatType
        this.maskSelectModalActive=true
      }else{
        this.showErrorMessage("CPAP機種が選択されていません。")
      }
    },
    maskSelect: function(maskInfo) {
      // マスク変更前の品目コード
      let deleteMaskItemCodes = this.data.maskInfo
      this.data.maskId = maskInfo.id
      this.data.maskType = maskInfo.maskType
      this.data.maskItemCode = maskInfo.itemCode1
      this.data.cushionSize = maskInfo.cushionSize
      this.data.frameSize = maskInfo.frameSize
      this.data.fixingMethod = maskInfo.fixingMethod
      this.data.maskInfo = maskInfo.items
      this.getDirectionsItemList()
      if(this.data.maskInfo){
        for(let items of this.data.maskInfo){
          let addShipping = this.directionsItemList.filter(val => val.itemCode == items.itemCode)
          if(addShipping.length > 0){
            // 変更後の出荷指示フラグ=true
            addShipping[0].shippingInstructionsFlg = true
          }
        }
      }
      if(deleteMaskItemCodes){
        // 旧マスクの見積を削除
        for(let items of deleteMaskItemCodes){
          let deleteDirection = this.directionsItemList.filter(val => val.itemCode == items.itemCode)
          this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => val.itemCode != items.itemCode)
          if(deleteDirection.length > 0){
            deleteDirection[0].estimateCode= ""
            deleteDirection[0].quotationDetailsNumber= ""
            deleteDirection[0].shippingInstructionsFlg = false
          }
        }
      }
      // this.controlDirectionsItem(this.data.maskItemCode,"mask")
    },
    controlDirectionsItem: function(directionsItemCode, targetType) {
      for(let directionsItem of this.directionsItemList){
        let target = this.cpapAccessories.find(val => val.itemCode == directionsItem.itemCode)
        let estimate = this.data.estimateDetailCode.find(val => val.itemCode == directionsItem.itemCode)
        let oldEstimate = this.saveOldEstimateDetailCode.find(val => val.itemCode == directionsItem.itemCode && val.itemCode != directionsItemCode)
        if(target && target.type && target.type == targetType){
          if(directionsItem.itemCode == directionsItemCode){
            if(!estimate){
              // 変更後の出荷指示フラグ=true
              directionsItem.shippingInstructionsFlg = true
            }
          }else{
            // それ以外の出荷指示フラグ=false
            directionsItem.shippingInstructionsFlg = false
            if(oldEstimate){
              if(targetType == "cpap" || targetType == "moist" || targetType == "module"){
                // 変更前の回収指示フラグ=true
                directionsItem.collectionInstructionsFlg = true
              }
            }
          }
        }
      }
    },
    isRequiredSerial: function() {
      // 預託在庫からの処方申込みの場合は、「シリアル」が必須
      return this.data.depositUseFlag
    },
    getDepositoryCodeMaster: function() {
      this.depositoryCodeMaster = []
      if(!this.officeCode) return
      // Web Api Call
      var _this = this;
      if(!_this.data.belongsId){
         return;
      }
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getCpapStorageLocationPOST({
            body:{
              belongsId: _this.data.belongsId,
              institutionId: _this.data.institutionId,
              salesOfficeCode: "J"+_this.officeCode
            }
          });
        },
        async function(result){
          _this.depositoryCodeMaster = result.obj;
          if(!_this.data.depositoryCode){
            var targetOffice = _this.depositoryCodeMaster.find(val => val.depositoryCode=="J"+_this.officeCode)
            if(targetOffice){
              _this.data.depositoryCode = targetOffice.depositoryCode
            }
          }
        },
        function(result){
          _this.showErrorMessage(result);
          _this.webHtApiErr = true
        }
      );
    },
    getDirectionsItemList: function() {
      let saveDirectionsItemList = []//フラグ保存用
      if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
        // 処方変更でない場合
        saveDirectionsItemList = this.directionsItemList
        this.directionsItemList = []
      }
      this.data.circuitItemCode = ""
      var setItem = this.cpapSetItems.find(val => val.cpapItemCode == this.data.model)
      var model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType && item.itemCode == this.data.model)
      if(!model && this.data.reportFormatType){
        model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType)
        setItem = this.cpapSetItems.find(val => val.cpapItemCode == model.itemCode)
      }

      var estimateList = this.data.estimateDetailCode && this.data.estimateDetailCode.length > 0 ? this.data.estimateDetailCode : []
      var provisionalTakenOutItems = this.data.provisionalTakenOutItems && this.data.provisionalTakenOutItems.length > 0 ? this.data.provisionalTakenOutItems : []
      for(var estimate of estimateList){
        if(!this.data.depositUseOrderDetail){
          estimate.depositUseOrderId = ""
          estimate.orderDetailNumber = ""
        }else{
          for(var detail of this.data.depositUseOrderDetail){
            var target = detail.items.find(val => val.itemCode==estimate.itemCode)
            if(target){
              estimate.depositUseOrderId = detail.orderId
              estimate.orderDetailNumber = target.orderDetailsNumber
              if (this.isEscrow && this.bulkQuotationModalActive) {
                // 預託処方変更の場合、一括選択で預託オーダーIDを付与しない
                estimate.depositUseOrderId = "";
              }
              break;
            }
          }
        }
      }
      // CPAP本体
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      let cpapItems = model ? model.items : []
      for(var item of cpapItems){
        if(this.isTemp && this.data.model != item.itemCode) continue

        let target = estimateList.find(val => val.itemCode == item.itemCode)
        let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == item.itemCode)
        if(target) this.data.model = item.itemCode
        if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
          // 処方変更でない場合
          // 出荷指示フラグ
          let shipping = saveDirectionsItemList.find(val => val.itemCode == item.itemCode)
          if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
            //新規、再開、仮持出初期表示の場合　
            shipping = target
          }
          let shippingFlg = false
          if(shipping) shippingFlg = shipping.shippingInstructionsFlg
          this.directionsItemList.push({
            itemCode:item.itemCode,
            name:item.itemName,
            estimateCode:target ? target.estimateCode : "",
            quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
            depositUseOrderId:target ? target.depositUseOrderId : "",
            orderDetailNumber:target ? target.orderDetailNumber : "",
            tempDeviceId : tempDevice ? tempDevice.id : "",
            serial: this.data.serial ? this.data.serial : "",
            shippingInstructionsFlg: shippingFlg
          })
        }else{
          var cpap = this.directionsItemList.find(val => val.itemCode == item.itemCode)
          if(!cpap){
            var sameNameCpap = this.directionsItemList.find(val => val.name == item.itemName)
            //指示書未選択で同名の機種がある場合
            if(sameNameCpap){
              var oldEstimateCpap = this.saveOldEstimateDetailCode.find(val => val.itemCode == item.itemCode)
              if(oldEstimateCpap){
                oldEstimateCpap.shippingInstructionsFlg = false
                oldEstimateCpap.collectionInstructionsFlg = false
                estimateList.push(oldEstimateCpap)
                sameNameCpap.itemCode = oldEstimateCpap.itemCode
                sameNameCpap.estimateCode = oldEstimateCpap.estimateCode
                sameNameCpap.quotationDetailsNumber = oldEstimateCpap.quotationDetailsNumber
                sameNameCpap.depositUseOrderId = oldEstimateCpap.depositUseOrderId
                sameNameCpap.orderDetailNumber = oldEstimateCpap.orderDetailNumber
                sameNameCpap.tempDeviceId = tempDevice ? tempDevice.id : ""
                sameNameCpap.serial = this.data.serial ? this.data.serial : ""
                sameNameCpap.shippingInstructionsFlg = false
                sameNameCpap.collectionInstructionsFlg = false
              }
            }else{
              this.directionsItemList.push({
                itemCode:item.itemCode,
                name:item.itemName,
                estimateCode:target ? target.estimateCode : "",
                quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                depositUseOrderId:target ? target.depositUseOrderId : "",
                orderDetailNumber:target ? target.orderDetailNumber : "",
                tempDeviceId : tempDevice ? tempDevice.id : "",
                serial: this.data.serial ? this.data.serial : "",
                shippingInstructionsFlg:target ? target.shippingInstructionsFlg : false,
                collectionInstructionsFlg:target ? target.collectionInstructionsFlg : false
              })
            }
          }else{
            cpap.estimateCode = target ? target.estimateCode : ""
            cpap.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
            cpap.depositUseOrderId = target ? target.depositUseOrderId : ""
            cpap.orderDetailNumber = target ? target.orderDetailNumber : ""
            cpap.tempDeviceId = tempDevice ? tempDevice.id : ""
            cpap.serial = this.data.serial ? this.data.serial : ""
          }
        }
      }

      if(this.data.useMoist && setItem.moistItemCode){
        // 加湿器
        if(setItem.moist){
          for(let moistItem of setItem.moist){
            let target = estimateList.find(val => val.itemCode == moistItem.itemCode)
            let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == moistItem.itemCode)

            if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
              // 処方変更でない場合
              // 出荷指示フラグ
              let shipping = saveDirectionsItemList.find(val => val.itemCode == moistItem.itemCode)
              let shippingFlg = false
              if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
                //新規、再開、仮持出初期表示の場合　
                shipping = target
              }
              if(shipping) shippingFlg = shipping.shippingInstructionsFlg
              this.directionsItemList.push({
                  itemCode:moistItem.itemCode,
                  name:moistItem.itemName,
                  estimateCode:target ? target.estimateCode : "",
                  quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                  orderDetailNumber:target ? target.orderDetailNumber : "",
                  tempDeviceId : tempDevice ? tempDevice.id : "",
                  serial : this.data.moistSerial ? this.data.moistSerial : "",
                  shippingInstructionsFlg: shippingFlg
                })
            }else{
              var moist = this.directionsItemList.find(val => val.itemCode == moistItem.itemCode)
              if(!moist){
                var sameNameMoist = this.directionsItemList.find(val => val.name == moistItem.itemName)
                //指示書未選択で同名の加湿器がある場合
                if(sameNameMoist){
                var oldEstimateMoist = this.saveOldEstimateDetailCode.find(val => val.itemCode == moistItem.itemCode)
                  if(oldEstimateMoist){
                    oldEstimateMoist.shippingInstructionsFlg = false
                    oldEstimateMoist.collectionInstructionsFlg = false
                    estimateList.push(oldEstimateMoist)
                    sameNameMoist.itemCode = oldEstimateMoist.itemCode
                    sameNameMoist.estimateCode = oldEstimateMoist.estimateCode
                    sameNameMoist.quotationDetailsNumber = oldEstimateMoist.quotationDetailsNumber
                    sameNameMoist.depositUseOrderId = oldEstimateMoist.depositUseOrderId
                    sameNameMoist.orderDetailNumber = oldEstimateMoist.orderDetailNumber
                    sameNameMoist.tempDeviceId = tempDevice ? tempDevice.id : ""
                    sameNameMoist.serial = this.data.serial ? this.data.serial : ""
                    sameNameMoist.shippingInstructionsFlg = false
                    sameNameMoist.collectionInstructionsFlg = false
                  }
                }else{
                  this.directionsItemList.push({
                    itemCode:moistItem.itemCode,
                    name:moistItem.itemName,
                    estimateCode:target ? target.estimateCode : "",
                    quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                    orderDetailNumber:target ? target.orderDetailNumber : "",
                    tempDeviceId : tempDevice ? tempDevice.id : "",
                    serial : this.data.moistSerial ? this.data.moistSerial : "",
                    shippingInstructionsFlg:target ? target.shippingInstructionsFlg : false,
                    collectionInstructionsFlg:target ? target.collectionInstructionsFlg : false
                  })
                }
              }else{
                moist.Code = moistItem.itemCode
                moist.name = moistItem.itemName
                moist.estimateCode = target ? target.estimateCode : ""
                moist.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
                moist.orderDetailNumber = target ? target.orderDetailNumber : ""
                moist.tempDeviceId = tempDevice ? tempDevice.id : ""
                moist.serial = this.data.moistSerial ? this.data.moistSerial : ""
              }
            }
          }
        }else{
          let target = estimateList.find(val => val.itemCode == setItem.moistItemCode)
          let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == setItem.moistItemCode)
          if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
            // 処方変更でない場合
            // 出荷指示フラグ
            let shipping = saveDirectionsItemList.find(val => val.itemCode == setItem.moistItemCode)
            let shippingFlg = false
            if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
              //新規、再開、仮持出初期表示の場合　
              shipping = target
            }
            if(shipping) shippingFlg = shipping.shippingInstructionsFlg
            this.directionsItemList.push({
              itemCode:setItem.moistItemCode,
              name:setItem.moistItemName,
              estimateCode:target ? target.estimateCode : "",
              quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
              depositUseOrderId:target ? target.depositUseOrderId : "",
              orderDetailNumber:target ? target.orderDetailNumber : "",
              tempDeviceId : tempDevice ? tempDevice.id : "",
              serial : this.data.moistSerial ? this.data.moistSerial : "",
              shippingInstructionsFlg: shippingFlg
            })
          }else{
            var moist = this.directionsItemList.find(val => val.itemCode == setItem.moistItemCode)
            if(!moist){
              var sameNameMoist = this.directionsItemList.find(val => val.name == setItem.moistItemName)
              //指示書未選択で同名の加湿器がある場合
              if(sameNameMoist){
                var oldEstimateMoist = this.saveOldEstimateDetailCode.find(val => val.itemCode == setItem.moistItemCode)
                if(oldEstimateMoist){
                  oldEstimateMoist.shippingInstructionsFlg = false
                  oldEstimateMoist.collectionInstructionsFlg = false
                  estimateList.push(oldEstimateMoist)
                  sameNameMoist.itemCode = oldEstimateMoist.itemCode
                  sameNameMoist.estimateCode = oldEstimateMoist.estimateCode
                  sameNameMoist.quotationDetailsNumber = oldEstimateMoist.quotationDetailsNumber
                  sameNameMoist.depositUseOrderId = oldEstimateMoist.depositUseOrderId
                  sameNameMoist.orderDetailNumber = oldEstimateMoist.orderDetailNumber
                  sameNameMoist.tempDeviceId = tempDevice ? tempDevice.id : ""
                  sameNameMoist.serial = this.data.serial ? this.data.serial : ""
                  sameNameMoist.shippingInstructionsFlg = false
                  sameNameMoist.collectionInstructionsFlg = false
                }
              }else{
                this.directionsItemList.push({
                  itemCode:setItem.moistItemCode,
                  name:setItem.moistItemName,
                  estimateCode:target ? target.estimateCode : "",
                  quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                  depositUseOrderId:target ? target.depositUseOrderId : "",
                  orderDetailNumber:target ? target.orderDetailNumber : "",
                  tempDeviceId : tempDevice ? tempDevice.id : "",
                  serial : this.data.moistSerial ? this.data.moistSerial : "",
                  shippingInstructionsFlg:target ? target.shippingInstructionsFlg : false,
                  collectionInstructionsFlg:target ? target.collectionInstructionsFlg : false
                })
              }
            }else{
              moist.itemCode = setItem.moistItemCode
              moist.name = setItem.moistItemName
              moist.estimateCode = target ? target.estimateCode : ""
              moist.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
              moist.depositUseOrderId = target ? target.depositUseOrderId : ""
              moist.orderDetailNumber = target ? target.orderDetailNumber : ""
              moist.tempDeviceId = tempDevice ? tempDevice.id : ""
              moist.serial = this.data.moistSerial ? this.data.moistSerial : ""
            }
          }
        }
      }

      if(this.data.useModule && setItem.module){
        // 通信モジュール
        for(let moduleItem of setItem.module){
          if(this.data.moduleItemCode && this.data.moduleItemCode != moduleItem.itemCode) continue
          let target = estimateList.find(val => val.itemCode == moduleItem.itemCode)
          let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == moduleItem.itemCode)
          if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
            // 処方変更でない場合
            // 出荷指示フラグ
            let shipping = saveDirectionsItemList.find(val => val.itemCode == moduleItem.itemCode)
            let shippingFlg = false
            if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
              //新規、再開、仮持出初期表示の場合　
              shipping = target
            }
            if(shipping) shippingFlg = shipping.shippingInstructionsFlg
            this.directionsItemList.push({
              itemCode:moduleItem.itemCode,
              name:moduleItem.itemName,
              estimateCode:target ? target.estimateCode : "",
              quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
              depositUseOrderId:target ? target.depositUseOrderId : "",
              orderDetailNumber:target ? target.orderDetailNumber : "",
              tempDeviceId : tempDevice ? tempDevice.id : "",
              serial : this.data.moduleSerial ? this.data.moduleSerial : "",
              shippingInstructionsFlg: shippingFlg
            })
          }else{
            var moduleUnit = this.directionsItemList.find(val => val.itemCode == moduleItem.itemCode)
            if(!moduleUnit){
              var sameNameModule = this.directionsItemList.find(val => val.name == moduleItem.itemName)
              //指示書未選択で同名の通信モジュールがある場合
              if(sameNameModule){
                var oldEstimateModule = this.saveOldEstimateDetailCode.find(val => val.itemCode == moduleItem.itemCode)
                if(oldEstimateModule){
                  this.data.moduleItemCode = oldEstimateModule.itemCode
                  oldEstimateModule.shippingInstructionsFlg = false
                  oldEstimateModule.collectionInstructionsFlg = false
                  estimateList.push(oldEstimateModule)
                  sameNameModule.itemCode = oldEstimateModule.itemCode
                  sameNameModule.estimateCode = oldEstimateModule.estimateCode
                  sameNameModule.quotationDetailsNumber = oldEstimateModule.quotationDetailsNumber
                  sameNameModule.depositUseOrderId = oldEstimateModule.depositUseOrderId
                  sameNameModule.orderDetailNumber = oldEstimateModule.orderDetailNumber
                  sameNameModule.tempDeviceId = tempDevice ? tempDevice.id : ""
                  sameNameModule.serial = this.data.serial ? this.data.serial : ""
                  sameNameModule.shippingInstructionsFlg = false
                  sameNameModule.collectionInstructionsFlg = false
                }
              }else{
                this.directionsItemList.push({
                  itemCode:moduleItem.itemCode,
                  name:moduleItem.itemName,
                  estimateCode:target ? target.estimateCode : "",
                  quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                  depositUseOrderId:target ? target.depositUseOrderId : "",
                  orderDetailNumber:target ? target.orderDetailNumber : "",
                  tempDeviceId : tempDevice ? tempDevice.id : "",
                  serial : this.data.moduleSerial ? this.data.moduleSerial : "",
                  shippingInstructionsFlg:target ? target.shippingInstructionsFlg : false,
                  collectionInstructionsFlg:target ? target.collectionInstructionsFlg : false
                })
              }
            }else{
              moduleUnit.itemCode = moduleItem.itemCode
              moduleUnit.name = moduleItem.itemName
              moduleUnit.estimateCode = target ? target.estimateCode : ""
              moduleUnit.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
              moduleUnit.depositUseOrderId = target ? target.depositUseOrderId : ""
              moduleUnit.orderDetailNumber = target ? target.orderDetailNumber : ""
              moduleUnit.tempDeviceId = tempDevice ? tempDevice.id : ""
              moduleUnit.serial = this.data.moduleSerial ? this.data.moduleSerial : ""
            }
          }
        }
      }

      // if(this.data.maskInfo && this.data.maskInfo.length > 0){
      if(!this.data.depositUseFlag && this.data.maskInfo && this.data.maskInfo.length > 0){
        // NOTE: マスクと回路は預託の対象ではないので、depositUseFlagがオンの場合をはじいている
        for(var mask of this.data.maskInfo){
          let target = estimateList.find(val => val.itemCode == mask.itemCode)
          let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == mask.itemCode)
          if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
            // 処方変更でない場合
            // 出荷指示フラグ
            let shipping = saveDirectionsItemList.find(val => val.itemCode == mask.itemCode)
            let shippingFlg = false
            if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
              //新規、再開、仮持出初期表示の場合　
              shipping = target
            }
            if(shipping) shippingFlg = shipping.shippingInstructionsFlg
            this.directionsItemList.push({
            itemCode:mask.itemCode,
            name:mask.itemName,
            estimateCode:target ? target.estimateCode : "",
            quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
            depositUseOrderId:target ? target.depositUseOrderId : "",
            orderDetailNumber:target ? target.orderDetailNumber : "",
            tempDeviceId : tempDevice ? tempDevice.id : "",
            shippingInstructionsFlg: shippingFlg
          })
          }else{
            var maskItem = this.directionsItemList.find(val => val.itemCode == mask.itemCode)
            if(!maskItem){
              var sameNameMask = this.directionsItemList.find(val => val.name == mask.itemName)
              //指示書未選択で同名のマスクがある場合
              if(sameNameMask){
                var oldEstimateMask = this.saveOldEstimateDetailCode.find(val => val.itemCode == mask.itemCode)
                  if(oldEstimateMask){
                    oldEstimateMask.shippingInstructionsFlg = false
                    oldEstimateMask.collectionInstructionsFlg = false
                    estimateList.push(oldEstimateMask)
                    sameNameMask.itemCode = oldEstimateMask.itemCode
                    sameNameMask.estimateCode = oldEstimateMask.estimateCode
                    sameNameMask.quotationDetailsNumber = oldEstimateMask.quotationDetailsNumber
                    sameNameMask.depositUseOrderId = oldEstimateMask.depositUseOrderId
                    sameNameMask.orderDetailNumber = oldEstimateMask.orderDetailNumber
                    sameNameMask.tempDeviceId = tempDevice ? tempDevice.id : ""
                    sameNameMask.shippingInstructionsFlg = false
                    sameNameMask.collectionInstructionsFlg = false
                  }
              }else{
                this.directionsItemList.push({
                  itemCode:mask.itemCode,
                  name:mask.itemName,
                  estimateCode:target ? target.estimateCode : "",
                  quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                  depositUseOrderId:target ? target.depositUseOrderId : "",
                  orderDetailNumber:target ? target.orderDetailNumber : "",
                  tempDeviceId : tempDevice ? tempDevice.id : "",
                  shippingInstructionsFlg: target ? target.shippingInstructionsFlg : false,
                  collectionInstructionsFl: target ? target.collectionInstructionsFlg : false
                })
              }
            }else{
              maskItem.itemCode = mask.itemCode
              maskItem.name = mask.itemName
              maskItem.estimateCode = target ? target.estimateCode : ""
              maskItem.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
              maskItem.depositUseOrderId = target ? target.depositUseOrderId : ""
              maskItem.orderDetailNumber = target ? target.orderDetailNumber : ""
              maskItem.tempDeviceId = tempDevice ? tempDevice.id : ""
            }
          }
        }
      }
      var circuitValue = this.data.prescriptionItems ? this.data.prescriptionItems.find(val => val.itemName == "KOKTY") : ""

      // if(circuitValue && circuitValue.value){
      if(!this.data.depositUseFlag && circuitValue && circuitValue.value){
        // NOTE: マスクと回路は預託の対象ではないので、depositUseFlagがオンの場合をはじいている
        // 回路
        var circuitList = setItem.circuit ? setItem.circuit[circuitValue.value] : ""
        if(circuitList && circuitList.length > 0){
          for(var circuit of circuitList){
            let target = estimateList.find(val => val.itemCode == circuit.itemCode)
            let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == circuit.itemCode)

            if(!this.isChangeValue && this.data.kind != this.cpapKindMap.applicationChange){
              // 処方変更でない場合
              // 出荷指示フラグ
              let shipping = saveDirectionsItemList.find(val => val.itemCode == circuit.itemCode)
              let shippingFlg = false
              if((this.data.kind == this.cpapKindMap.application || this.data.kind == this.cpapKindMap.applicationResume || this.data.kind == this.cpapKindMap.applicationTempRemoval) && (saveDirectionsItemList.length == 0)){
                //新規、再開、仮持出初期表示の場合　
                shipping = target
              }
              if(shipping) shippingFlg = shipping.shippingInstructionsFlg
              this.directionsItemList.push({
                itemCode:circuit.itemCode,
                name:circuit.itemName,
                estimateCode:target ? target.estimateCode : "",
                quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                depositUseOrderId:target ? target.depositUseOrderId : "",
                orderDetailNumber:target ? target.orderDetailNumber : "",
                tempDeviceId : tempDevice ? tempDevice.id : "",
                shippingInstructionsFlg: shippingFlg
              })
              this.data.circuitItemCode = this.data.circuitItemCode + "_" + circuit.itemCode
            }else{
              var circuitItem = this.directionsItemList.find(val => val.itemCode == circuit.itemCode)
              if(!circuitItem){
                var sameNameCircuit = this.directionsItemList.find(val => val.name == circuit.itemName)
                //指示書未選択で同名の回路がある場合
                if(sameNameCircuit){
                  var oldEstimateCircuit = this.saveOldEstimateDetailCode.find(val => val.itemCode == circuit.itemCode)
                    if(oldEstimateCircuit){
                      oldEstimateCircuit.shippingInstructionsFlg = false
                      oldEstimateCircuit.collectionInstructionsFlg = false
                      estimateList.push(oldEstimateCircuit)
                      sameNameCircuit.itemCode = oldEstimateCircuit.itemCode
                      sameNameCircuit.estimateCode = oldEstimateCircuit.estimateCode
                      sameNameCircuit.quotationDetailsNumber = oldEstimateCircuit.quotationDetailsNumber
                      sameNameCircuit.depositUseOrderId = oldEstimateCircuit.depositUseOrderId
                      sameNameCircuit.orderDetailNumber = oldEstimateCircuit.orderDetailNumber
                      sameNameCircuit.tempDeviceId = tempDevice ? tempDevice.id : ""
                      sameNameCircuit.shippingInstructionsFlg = false
                      sameNameCircuit.collectionInstructionsFlg = false
                    }
                }else{
                  this.directionsItemList.push({
                    itemCode:circuit.itemCode,
                    name:circuit.itemName,
                    estimateCode:target ? target.estimateCode : "",
                    quotationDetailsNumber:target ? target.quotationDetailsNumber : "",
                    depositUseOrderId:target ? target.depositUseOrderId : "",
                    orderDetailNumber:target ? target.orderDetailNumber : "",
                    tempDeviceId : tempDevice ? tempDevice.id : "",
                    shippingInstructionsFlg: target ? target.shippingInstructionsFlg : false,
                    collectionInstructionsFl: target ? target.collectionInstructionsFlg : false
                  })
                  this.data.circuitItemCode = this.data.circuitItemCode + "_" + circuit.itemCode
                }
              }else{
                circuitItem.itemCode = circuit.itemCode
                circuitItem.name = circuit.itemName
                circuitItem.estimateCode = target ? target.estimateCode : ""
                circuitItem.quotationDetailsNumber = target ? target.quotationDetailsNumber : ""
                circuitItem.depositUseOrderId = target ? target.depositUseOrderId : ""
                circuitItem.orderDetailNumber = target ? target.orderDetailNumber : ""
                circuitItem.tempDeviceId = tempDevice ? tempDevice.id : ""
                this.data.circuitItemCode = this.data.circuitItemCode + "_" + circuit.itemCode
              }
            }
          }
        }
      }

      if(estimateList && estimateList.length > 0){
        for(var estimate of estimateList){
          let target = this.directionsItemList.find(val => val.itemCode == estimate.itemCode)
          let tempDevice = provisionalTakenOutItems.find(val => val.itemCode == estimate.itemCode)
          // 追加済みの指示書未選択のものは除外
          let addedTarget = this.directionsItemList.find(val => val.name == estimate.itemName)
          if(target) {
            if(estimate.itemCode != ""){
              continue
            }
          }
          if(addedTarget) continue
          this.directionsItemList.push({
            itemCode:"",
            name:estimate.itemName,
            estimateCode: estimate.estimateCode,
            quotationDetailsNumber:estimate.quotationDetailsNumber,
            orderDetailNumber:estimate.orderDetailNumber,
            tempDeviceId : tempDevice ? tempDevice.id : "",
            depositUseOrderId:target ? target.depositUseOrderId : "",
            shippingInstructionsFlg:estimate ? estimate.shippingInstructionsFlg : false,
            collectionInstructionsFlg:estimate ? estimate.collectionInstructionsFlg : false
          })
        }
      }
      this.renderKey = !this.renderKey
    },
    changeModule: function() {
      this.getDirectionsItemList();
      this.controlDirectionsItem(this.data.moduleItemCode,"module");
    },
    getConsistencyCheck: function() {
      var target
      if(this.data.depositUseFlag){
        // 預託機使用の場合
        target = this.directionsItemList.find(val => !val.orderDetailNumber)
      }else{
        target = this.directionsItemList.find(val => !val.itemCode || !val.quotationDetailsNumber)
      }
      if(target){
        return false
      }
      return true
    },
    transferTempOrderCheck: function() {
      let result = { isError:false, msg:"" }
      if(!this.isResume){
        return result
      }
      var setItem = this.cpapSetItems.find(val => val.cpapItemCode == this.data.model)
      var model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType && item.itemCode == this.data.model)
      if(!model && this.data.reportFormatType){
        model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType)
        setItem = this.cpapSetItems.find(val => val.cpapItemCode == model.itemCode)
      }
      // CPAP本体の仮持出オーダーが選択済みかチェック
      let isCpapSelect = false
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      if(model){
        for(var item of model.items){
          let tempDevice = this.data.provisionalTakenOutItems.find(val => val.itemCode == item.itemCode)
          if(tempDevice || this.data.serial){
            isCpapSelect = true
            break;
          }
        }
      }

      // 加湿器有りの場合、仮持出オーダーが選択済みかチェック
      let isMoistSelect = false
      if(this.data.useMoist && setItem.moistItemCode){
        if(setItem.moist){
          for(let moistItem of setItem.moist){
            let tempDevice = this.data.provisionalTakenOutItems.find(val => val.itemCode == moistItem.itemCode)
            if(tempDevice || this.data.moistSerial){
              isMoistSelect = true
              break;
            }
          }
        }else{
          let tempDevice = this.data.provisionalTakenOutItems.find(val => val.itemCode == setItem.moistItemCode)
          if(tempDevice || this.data.moistSerial) {
            isMoistSelect = true
          }
        }
      }else{
        isMoistSelect = true
      }

      // 通信モジュール有りの場合、仮持出オーダーが選択済みかチェック
      let isModuleSelect = false
      if(this.data.useModule && setItem.module){
        for(let moduleItem of setItem.module){
          if(this.data.moduleItemCode && this.data.moduleItemCode != moduleItem.itemCode) continue
          let tempDevice = this.data.provisionalTakenOutItems.find(val => val.itemCode == moduleItem.itemCode)
          if(tempDevice || this.data.moduleSerial) {
            isModuleSelect = true
            break;
          }
        }
      }else{
        isModuleSelect = true
      }
      // 消耗品の仮持出オーダーが選択済みかチェック
      let isConsumablesSelect = true
      for(let estimate of this.data.estimateDetailCode){
        let target = this.cpapAccessories.find(val => val.itemCode == estimate.itemCode)
        if(target){
          switch(target.type){
            case "cpap":
            case "moist":
            case "module":
              break;
            case "mask":
            case "circuit":
            case "flame":
            case "headgear":
            case "maskCushion":
            case "maskHeadgear":
              let tempDevice = this.data.provisionalTakenOutItems.find(val => val.itemCode == estimate.itemCode)
              if(tempDevice) {
                isConsumablesSelect = true
                break;
              }else{
                isConsumablesSelect = false
                break;
              }
          }
        }
      }

      if(!isCpapSelect){
        result.isError = true
        result.msg = result.msg + "CPAP機器の仮持出情報が選択されていません。\n"
      }
      if(!isMoistSelect){
        result.isError = true
        result.msg = result.msg + "加湿器の仮持出情報が選択されていません。\n"
      }
      if(!isModuleSelect){
        result.isError = true
        result.msg = result.msg + "通信モジュールの仮持出情報が選択されていません。\n"
      }
      if(!isConsumablesSelect){
        result.isError = true
        result.msg = result.msg + "消耗品の仮持出情報が選択されていません。\n"
      }
      return result
    },
    cpapConsistencyCheckErr: function() {
      var target = this.directionsItemList.find(val => val.itemCode == this.data.model)
      if(!target || !target.quotationDetailsNumber || !target.orderDetailNumber){
        return true
      }
      return false
    },
    cpapConsistencyCheckErr: function() {
      var target = this.directionsItemList.find(val => val.itemCode == this.data.model)
      // 預託処方変更ではバリデーションをスルー　// 2023.12.12
      if(!(this.data.kind == this.cpapKindMap.applicationChange) && (!target || !target.quotationDetailsNumber || !target.orderDetailNumber)){
        return true
      }
      return false
    },
    modulchangedCheck: function(areaName) {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == areaName)
          // 変更項目の有無を返却
          return target && target.modulChange
        }
      }
    },
    addCheck: function(areaName) {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == areaName)
          // 変更項目の有無を返却
          if(areaName == "moistArea"){
            return target && target.moistAdd
          }else{
            return target && target.modulAdd
          }
        }
      }
    },
    singleChangedCheck: function(areaName,itemName) {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == areaName)
          if(target.items && target.items.length>0){
            let targetItem = target.items.find((val => val.itemName == itemName))
              // 変更項目の有無を返却
              return targetItem && target.isChange
          }
        }
      }
    },
    simultaneousExchangeCheck: function() {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == "moduleArea")
          // 変更項目の有無を返却
          return target && target.simultaneousExchange
        }
      }
      return false;
    },
    simultaneousExchange: function() {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          if(this.modulchangedCheck('moduleArea')){// 機種
            let target = this.data.changedItems.find(val => val.areaName == "moduleArea")
            if(target){
              // 申込時にモデム処方、機種情報に変更があれば同時交換対象外
              target.simultaneousExchange = false
            }
          }
        }
      }
    },
    simultaneousExchangeCheck2: function() {
      // CPAP本体がシリアル交換予定（出荷指示、回収指示ON）で見積が入っている場合モデム同時交換の注記表示
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        let cpapShipping = false
        let cpapCollection = false
        let cpapEstimate = ""
        if(!this.simultaneousExchangeCheck()){
          //申込時にモデム同時交換の場合は機器交換の為、シリアル交換不可
          if(this.data.estimateDetailCode.length > 0 && this.directionsItemList.length > 0){
            let cpap = this.data.estimateDetailCode.find(val => val.itemCode == this.data.model)
            let cpapDirections = this.directionsItemList.find(val => val.itemCode == this.data.model)
            if(cpap && cpapDirections){
              cpapShipping = cpapDirections.shippingInstructionsFlg
              cpapCollection = cpapDirections.collectionInstructionsFlg
              cpapEstimate = cpap.estimateCode
            }
          }
          if(cpapShipping && cpapCollection && (cpapEstimate != "")){
            return true;
          }
        }
      }
      return false;
    },
    saveSimultaneousExchangeCheck: function() {
      if(this.data.status == cpapRequestStatus.request || this.data.status == cpapRequestStatus.Approving){
        if(this.data.changedItems && this.data.changedItems.length>0){
          let target = this.data.changedItems.find(val => val.areaName == "moduleArea")
          // 変更項目の有無を返却
          return target && target.saveSimultaneousExchange
        }
      }
      return false;
    },
    moduleSimultaneousExchange: function() {
      //機種変更時
      let machineChangeFlag = this.singleChangedCheck('hardwareArea','reportFormatType');

      //申込時にモデム処方、機種情報に変更があれば同時交換対象外
      if(machineChangeFlag) this.simultaneousExchange();

      // 通信モジュール有→有の場合false
      let moduleSimultaneousExchangeFlag =false;
      moduleSimultaneousExchangeFlag = this.simultaneousExchangeCheck();

      // 保存している場合はtrue
      let saveModuleSimultaneousExchangeFlag =false;
      saveModuleSimultaneousExchangeFlag = this.saveSimultaneousExchangeCheck();

      var setItem = this.cpapSetItems.find(val => val.cpapItemCode == this.data.model)

      if(this.data.kind == cpapKindMap.applicationChange &&
         this.data.status == "1" &&
         machineChangeFlag &&
         moduleSimultaneousExchangeFlag){

        //同時交換の場合、比較用の旧見積情報からモデムを削除（預託処方変更を除く）
        this.data.oldEstimateDetailCode = this.data.oldEstimateDetailCode.filter(val=>{ return val.itemCode !== this.data.moduleItemCode});
        if(!saveModuleSimultaneousExchangeFlag){
          if(this.data.moduleItemCode){
            this.data.moduleItemCode = "";// 機種
          }
          if(this.data.moduleSerial){
            this.data.moduleSerial = "";// シリアル
          }
        }
      }
    },
    deleteTempDeviceInfo: function(code,index) {
      this.data.provisionalTakenOutItems = this.data.provisionalTakenOutItems.filter(val => {
        return val.itemCode!=code
      })
      this.directionsItemList[index].tempDeviceId = ""
    },
    deleteDepositUseOrderInfo: function(orderId, itemCode) {
      this.data.depositUseOrderDetail = this.data.depositUseOrderDetail.filter(val => {
        if(val.items.length > 0) return val.items[0].itemCode!=itemCode
      })
      for(var directionsItem of this.directionsItemList){
        if(directionsItem.depositUseOrderId == orderId && directionsItem.itemCode == itemCode){
          directionsItem.depositUseOrderId = ""
          directionsItem.orderDetailNumber = ""
          var target = this.cpapAccessories.find(val => val.itemCode == directionsItem.itemCode)
          if(target){
            switch(target.type){
              case "cpap":
                this.data.depositUseOrderId = ""
                break;
              case "moist":
                this.data.depositUseMoistId = ""
                break;
              case "module":
                this.data.depositUseModuleId = ""
                break;
            }
          }
          break;
        }
      }
      for(var estimateDetail of this.data.estimateDetailCode){
        if(estimateDetail.depositUseOrderId == orderId && estimateDetail.itemCode == itemCode){
          estimateDetail.depositUseOrderId = ""
          estimateDetail.orderDetailNumber = ""
          break;
        }
      }
    },
    orderSelectModalOn: function(orderId,code) {
      this.searchOrderSerialNumber = ""
      var target = this.cpapAccessories.find(val => val.itemCode == code)
      if(target){
        switch(target.type){
          case "cpap":
            this.searchOrderSerialNumber = this.data.serial
            break;
          case "moist":
            this.searchOrderSerialNumber = this.data.moistSerial
            break;
          case "module":
            this.searchOrderSerialNumber = this.data.moduleSerial
            break;
        }
      }
      this.searchDepositUseOrderId = orderId ? orderId : ""
      this.searchOrderItemCode = code
      this.cpapOrderSelectModalActive = true
    },
    deleteQuotation: function(code,name,index) {
      console.log(code)
      console.log(name)
      this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => {
        if(code){
          if(val.itemCode!=code) return true
        } else {
          if (val.itemName!=name) return true
        }
      })
      this.directionsItemList[index].estimateCode = ""
      this.directionsItemList[index].quotationDetailsNumber = ""
      this.getDirectionsItemList();
    },
    quotationModalOn: function(code,name) {
      this.quotationItemCode = code
      this.quotationItemName = name
      this.itemQuotationModalActive = true
    },
    setQuotationItem: function(quotationInfo) {
      var target = this.cpapAccessories.find(val => val.itemCode == this.quotationItemCode)
      for(let item of quotationInfo.items){
        if(this.quotationItemCode != item.itemCode) continue
        item.estimateCode = quotationInfo.quotationNumber
        if(target){
          switch(target.type){
            case "cpap":
              this.data.estimateCode = quotationInfo.quotationNumber
              break;
            case "moist":
              this.data.moistItemCode = item.itemCode
              break;
            case "module":
              this.data.moduleItemCode = item.itemCode
              break;
          }
        }
        this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => {
          if(this.quotationItemCode){
            if(val.itemCode != this.quotationItemCode) return true
          } else {
            if (val.itemName!=this.quotationItemName) return true
          }
        })
        this.data.estimateDetailCode.push(item)
      }
      this.quotationItemCode = ""
      this.quotationItemName = ""
      this.getDirectionsItemList();
    },
    // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）(getEscrowStock)
    getEscrowStock: async function() {
      var excuteApi = this.getEscrowStockPOST;
      var successCallBack = this.getEscrowStockPOSTSuccess;
      var errorCallBack = this.getEscrowStockPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getEscrowStockPOST: function(client) {
      return client.apis.externalCpap.getEscrowStockPOST({
        body:{
          hospitalCode:this.medicalInstitutionCode,
        }
      });
    },
    getEscrowStockPOSTSuccess: function(result) {
      this.escrowStockList = result.body.map((value) => value.items).flat();
      this.stockItemNameList = this.escrowStockList.map((value) => value.itemName);
      this.stockItemCodeList = this.escrowStockList.map((value) => value.itemCode);
      this.stockItemSeialList = this.escrowStockList.map((value) => value.serial);
    },
    getEscrowStockPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    // 院内在庫をWEBから取得し本体、加湿器、モジュールそれぞれプルダウンから選ぶ仕様に改修中でペンディング（2024年に持ち越し、フィリップス佐藤様より）
    // 2023.11現在、WEB/HTからのレスポンスだけではシリアルの古い順の並び替え及び本体、加湿器、モジュールのグルーピングは実現不可
    // ソフトコム側のAPIの改修無しで実現する場合、PCP側で院内在庫注文時にテーブルに在庫情報を保持し、預託在庫からの処方時にテーブルを検索する
    // selectionStock: function(event,selectItem,kinds) {
    //   if (selectItem) {
    //     let findStock = this.escrowStockList.find(val => val.itemCode == selectItem)
    //     if (kinds == 'moist') {
    //       this.data.moistSerial = JSON.stringify(findStock.serial).replace(/[\"]/g,"");
    //     } else if (kinds == 'module') {
    //       this.data.moduleSerial = JSON.stringify(findStock.serial).replace(/[\"]/g,"");
    //     }
    //   }
    // },
    setDirectionsItemList: function() {
      //機種変更時
      let machineChangeFlag = false
      let oldItemCode, oldMoistItemCode, oldCircuitItemCode, oldReportFormatType
      if(this.data.comparisonDatas){
        oldItemCode = this.data.comparisonDatas.find(val => val.itemName == "model")
        oldMoistItemCode = this.data.comparisonDatas.find(val => val.itemName == "moistItemCode")
        oldCircuitItemCode = this.data.comparisonDatas.find(val => val.itemName == "circuitItemCode")
        oldReportFormatType = this.data.comparisonDatas.find(val => val.itemName == "reportFormatType")
      }
      let oldModuleItemCode = ""
      if(oldItemCode){
        if(this.data.model != oldItemCode.value){
          machineChangeFlag = true
        }
      }
      let moist,module,mask
      // 通信モジュール有→有の場合false
      let moduleSimultaneousExchangeFlag =false;
      // 保存している場合はtrue
      let saveModuleSimultaneousExchangeFlag =false;
      if(this.data.changedItems && (this.data.changedItems.length > 0)){
        //加温加湿器
        moist = this.data.changedItems.find(val => val.areaName == "moistArea")
        //通信モジュール
        module = this.data.changedItems.find(val => val.areaName == "moduleArea")
        //マスク
        mask = this.data.changedItems.find(val => val.areaName == "maskArea")

        moduleSimultaneousExchangeFlag = module.simultaneousExchange

        saveModuleSimultaneousExchangeFlag = module.saveSimultaneousExchange
      }

      if(this.data.comparisonDatas && this.data.comparisonDatas.length >0){
        let moduleItem = this.data.comparisonDatas.find(val => val.itemName == "moduleItemCode")
        if(moduleItem){
          oldModuleItemCode = moduleItem.value
        }        
      }

      for(var directionsItem of this.directionsItemList){
        //指示書未選択のものは見積情報削除
        if(directionsItem.itemCode == ""){
          this.saveEstimateDetail.push({
            itemCode:directionsItem.itemCode,
            itemName:directionsItem.name,
            quotationDetailsNumber: directionsItem.quotationDetailsNumber,
            quantity: directionsItem.quantity,
            unit: directionsItem.unit,
            deliveryPrice: directionsItem.deliveryPrice,
            unitPrice: directionsItem.unitPrice,
            quotationPrice: directionsItem.quotationPrice,
            comment: directionsItem.comment,
            estimateCode: directionsItem.estimateCode,
            latestOrderRegisteredDate: directionsItem.latestOrderRegisteredDate,
            shippingInstructionsFlg: directionsItem.shippingInstructionsFlg? directionsItem.shippingInstructionsFlg:false,
            collectionInstructionsFlg: directionsItem.collectionInstructionsFlg? directionsItem.collectionInstructionsFlg:false
          })
          this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val => {
            return directionsItem.name.indexOf(val.itemName)==-1
          })
          directionsItem.estimateCode= ""
          directionsItem.quotationDetailsNumber= ""
        }
        let target = this.cpapAccessories.find(val => val.itemCode == directionsItem.itemCode)
        let setItem = this.cpapSetItems.find(val => val.cpapItemCode == this.data.model)
        if (this.isEscrow && (this.data.kind == this.cpapKindMap.applicationChange)) {
          if(!saveModuleSimultaneousExchangeFlag){// 保存済みの場合はスキップ
            // 預託処方変更時、変更元の預託オーダーIDは削除
            directionsItem.depositUseOrderId = "";
            this.data.depositUseOrderId = "";
          }
        }
        if(this.data.kind != cpapKindMap.application){
        if(target){
          switch(target.type){
              case "cpap":
                if(!saveModuleSimultaneousExchangeFlag){
                  //保存済みの初期表示の場合スキップ
                  if(machineChangeFlag){
                    //新機器
                    if(directionsItem.itemCode == this.data.model){
                      directionsItem.shippingInstructionsFlg = true
                    }
                  }
                }
                break;
              case "moist":
                if(!saveModuleSimultaneousExchangeFlag){
                  //保存済みの初期表示の場合スキップ
                  if(moist.moistAdd){
                    //追加
                    directionsItem.shippingInstructionsFlg = true
                  }
                  if(moist.isChange){
                    //変更
                    if(setItem){
                      if(oldMoistItemCode){
                        if(setItem.moistItemCode != oldMoistItemCode.value){
                          directionsItem.shippingInstructionsFlg = true
                        }
                      }
                    }

                  }
                }
                break;
              case "module":
                if(!saveModuleSimultaneousExchangeFlag){
                  if(module.modulAdd || module.modulChange){
                    //保存済みの初期表示の場合スキップ
                    //新モデム
                    if(directionsItem.itemCode == this.data.moduleItemCode){
                      directionsItem.shippingInstructionsFlg = true
                    }
                  }
                }
                if(this.data.kind == cpapKindMap.applicationChange &&
                  this.data.status == "1" &&
                  machineChangeFlag &&
                  moduleSimultaneousExchangeFlag){
                  //モデムの見積情報を削除
                  if(!saveModuleSimultaneousExchangeFlag){
                    //保存済みの初期表示の場合スキップ
                    this.data.estimateDetailCode = this.data.estimateDetailCode.filter(val=>{ return val.itemCode !== oldModuleItemCode});
                    directionsItem.estimateCode= ""
                    directionsItem.quotationDetailsNumber= ""
                  }
                  this.saveEstimateDetail.push({
                    itemCode:directionsItem.itemCode,
                    itemName:directionsItem.name,
                    quotationDetailsNumber: directionsItem.quotationDetailsNumber,
                    quantity: directionsItem.quantity,
                    unit: directionsItem.unit,
                    deliveryPrice: directionsItem.deliveryPrice,
                    unitPrice: directionsItem.unitPrice,
                    quotationPrice: directionsItem.quotationPrice,
                    comment: directionsItem.comment,
                    estimateCode: directionsItem.estimateCode,
                    latestOrderRegisteredDate: directionsItem.latestOrderRegisteredDate,
                    shippingInstructionsFlg: directionsItem.shippingInstructionsFlg? directionsItem.shippingInstructionsFlg:false,
                    collectionInstructionsFlg: directionsItem.collectionInstructionsFlg? directionsItem.collectionInstructionsFlg:false
                  })
                }
                break;
              case "mask":
                if(!saveModuleSimultaneousExchangeFlag){
                  //保存済みの初期表示の場合スキップ
                  if(mask.isChange){
                    //新マスク
                    if(directionsItem.itemCode == this.data.maskItemCode){
                      directionsItem.shippingInstructionsFlg = true
                    }
                  }
                }
                break;
              case "circuit":
                if(!saveModuleSimultaneousExchangeFlag){
                  //保存済みの初期表示の場合スキップ
                  if(oldCircuitItemCode){
                    // 預託新規⇒処方変更の場合、
                    if(oldCircuitItemCode.value == ""){
                      var cuitItemCode = ""
                        if(oldItemCode){
                          if(this.data.comparisonPrescriptionItems && this.data.comparisonPrescriptionItems.length > 0){
                            var circuitItems = ""
                            if(oldReportFormatType && oldReportFormatType.value == "6"){
                              circuitItems = this.data.comparisonPrescriptionItems.find(val => val.displayName == "チューブタイプ")
                            }else if(oldReportFormatType && oldReportFormatType.value != "6"){
                              circuitItems = this.data.comparisonPrescriptionItems.find(val => val.displayName == "呼吸回路タイプ")
                            }
                            if(circuitItems != ""){
                              var oldSetItem = this.cpapSetItems.find(val => val.cpapItemCode == oldItemCode.value)
                              if(oldSetItem){
                                var olditems = oldSetItem.circuit[circuitItems.value]
                                if(setItem){
                                  cuitItemCode = olditems[0].itemCode
                                }
                              }
                            }
                          }
                          if(cuitItemCode != ""){
                            if(cuitItemCode != directionsItem.itemCode){
                              directionsItem.shippingInstructionsFlg = true
                            }
                          }
                      }
                    } else{
                      oldCircuitItemCode = oldCircuitItemCode.value.split('_')
                      if(oldCircuitItemCode[1] != directionsItem.itemCode){
                        directionsItem.shippingInstructionsFlg = true
                      }
                    }
                  }
                }
                break;
            }
          }
        }
      }
    },
    estimateDisabled: function(directionsItemCode, estimateCode, InstructionsType) {
      // 指示書未選択の場合、出荷指示、回収指示非活性
      if(!directionsItemCode){
        return true
      }
      //見積選択済の場合、出荷指示、回収指示非活性
      if(estimateCode){
        return true
      }
      // マスク、回路の場合、指示チェックボックスは非活性(回収指示のみ)
      if(InstructionsType == "collection"){
        //処方変更以外の場合 回収指示非活性
        if(this.data.kind!=cpapKindMap.applicationChange){
          return true
        }
        let target = this.cpapAccessories.find(val => val.itemCode == directionsItemCode)
        if(target){
          switch(target.type){
            case "cpap":
            case "moist":
            case "module":
              return false
            case "mask":
            case "circuit":
            case "flame":
            case "headgear":
            case "maskCushion":
            case "maskHeadgear":
              return true
          }
        }
      }else{
        return false
      }
    },
    serialExchangeCheck: function() {
      let serialExchange = this.singleChangedCheck('hardwareArea','serial');
      let machineExchange = this.singleChangedCheck('hardwareArea','reportFormatType');
      let moistSerialExchange = this.singleChangedCheck('moistArea','moistSerial');
      let moduleSerialExchange = this.singleChangedCheck('moduleArea','moduleSerial');
      let moistMachineExchange;
      for (let content of this.data.prescriptionItems.filter(val=>{ return val.category===1})) {
        moistMachineExchange = this.singleChangedCheck('moistArea',content.displayName);
        if (moistMachineExchange == true) {
          break;
        }
      }
      let moduleMachineExchange;
      for (let content of this.data.prescriptionItems.filter(val=>{ return val.category===2})) {
        moduleMachineExchange = this.singleChangedCheck('moduleArea',content.displayName);
        if (moduleMachineExchange == true) {
          break;
        }
      }
      let oldMoist = this.data.oldEstimateDetailCode.find(val => val.itemCode == this.data.moistItemCode)
      if (oldMoist) {
        if (oldMoist.itemCode != this.data.moistItemCode) {
          moistMachineExchange = true;
        }
      }
      let oldModule = this.data.oldEstimateDetailCode.find(val => val.itemCode == this.data.moduleItemCode)
      if (oldModule) {
        if (oldModule.itemCode != this.data.moduleItemCode) {
          moduleMachineExchange = true;
        }
      }
      if (!machineExchange && serialExchange) {
        this.serialExchangeFlag = true;
      }
      if (!moistMachineExchange && moistSerialExchange) {
        this.serialExchangeFlag = true;
      }
      if (!moduleMachineExchange && moduleSerialExchange) {
        this.serialExchangeFlag = true;
      }
    },
    resumeExchangeCheck: function(directionsItemCode) {
      // 転院からの再開の場合
      if(this.isResume){
        // 転院前使用品目にないものはfalse
        let beforeItemCheck = this.data.beforeItems.find(val => val.itemCode == directionsItemCode)
        if(!beforeItemCheck){
          return false
        }
        let target = this.cpapAccessories.find(val => val.itemCode == directionsItemCode)
        if(target){
          // 転院前とシリアルが違う場合はfalse
          switch(target.type){
            case "cpap":
              if(this.data.transferSerial){
                if(this.data.transferSerial != this.data.serial) return false
              }
              break;
            case "moist":
              if(this.data.transferMoistSerial){
                if(this.data.transferMoistSerial != this.data.moistSerial) return false
              }
              break;
            case "module":
              if(this.data.transferModuleSerial){
                if(this.data.transferModuleSerial != this.data.moduleSerial) return false
              }
              break;
            case "mask":
            case "flame":
            case "headgear":
            case "maskCushion":
            case "maskHeadgear":
            case "circuit":
              return false
          }
        }
        return true
      }
      return false;
    },
  },
  data() {
    var modelList = this.getCpapMaster();
    var cpapCodeMaster = this.getCpapCodeMaster();
    // var isChangeValue = false
    // if(this.changeValue!=undefined){
    //   isChangeValue = this.changeValue
    // }
    var cpapAccessories = this.getCpapAccessoryList();
    var cpapSetItems = this.getCpapSetItemList();
    var moduleList = ""
    var branchOfficeMaster= this.getSalesOfficeMaster();
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var officeCode = userInfo.salesOfficeCode
    var formatType = ""
    // 処方再開(転院)判定
    var isResume = false;
    if(this.resume){
      isResume = this.resume;
    }
    //　コメント判定
    var isComment = true;
    if(!this.comment){
      isComment = this.comment;
    }
    if(this.data){
      var model = modelList.find(item => item.itemCode == this.data.model)
      if(model){
        formatType = model.reportFormatType
      }
      var setItem = cpapSetItems.find(val => val.cpapItemCode == this.data.model)
      if(setItem && setItem.module){
        moduleList = setItem.module
      }
    }
    if(!this.data.shippingDate){
      this.data.shippingDate = this.yyyy_hyp_MM_hyp_dd(new Date())
    }
    const isEscrow = this.$route.params["isEscrow"] ? this.$route.params["isEscrow"]:this.data.depositUseFlag;
    const medicalInstitutionCode = userInfo.medicalInstitutionCode;
    let escrowStockList = [];
    let stockItemNameList = [];
    let stockItemCodeList = [];
    let stockItemSeialList = [];
    if(isEscrow){
      // 預託の場合、初期値設定
      if(!(this.data.depositCancelReasonCode && this.data.depositCancelReasonCode.length > 0)) this.data.depositCancelReasonCode = "JX"// その他
      if(!(this.data.depositBillingCurrentMonth && this.data.depositBillingCurrentMonth.length > 0)) this.data.depositBillingCurrentMonth = "002"// レンタル請求なし
    }
    return {
      modelList,
      quotationModalActive: false,
      bulkQuotationModalActive: false,
      itemQuotationModalActive: false,
      patientModalActive: false,
      cpapPatientRegisterStatus:cpapPatientRegisterStatus,
      cpapShippingMethodList:cpapShippingMethodList,
      cpapSenderMaster:cpapSenderMaster,
      cpapCodeMaster,
      departmentMaster:[],
      orderProcessType:[],
      rentalType:[],
      customerCategory:[],
      strategicMeasures:[],
      reserve:[],
      deliveryTimeZone:[],
      searchTargetPostCode:"",
      searchTargetAddress:null,
      maskSelectModalActive:false,
      formatType,
      cpapKindMap:cpapKindMap,
      cpapAccessories,
      cpapSetItems,
      isChangeValue:this.changeValue,
      cpapStockModalActive:false,
      cpapDirectShippingList:cpapDirectShippingList,
      cpapLeaseUpList:cpapLeaseUpList,
      isTemp:this.temp,
      tempDeviceSelectModalActive:false,
      escrowDeviceSelectModalActive:false, // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
      targetType:"",
      searchModel:"",
      searchItemCode:"",
      searchSerial:"",
      branchOfficeMaster,
      officeCode,
      depositoryCodeMaster:[],
      billedCurrentMonth:[],
      cancelCodeMaster:[],
      webHtApiErr:false,
      directionsItemList:[],
      cpapOrderSelectModalActive:false,
      renderKey:true,
      isResume,
      moduleList,
      searchDepositUseOrderId:"",
      searchOrderItemCode:"",
      searchOrderSerialNumber:"",
      // changeBeforeUseMoist:true,
      // beforeMoistDate:""
      changeBeforeUseModule:true,
      beforeModuleDate:"",
      quotationItemCode:"",
      quotationItemName:"",
      modelChangeFlg:false,
      invalidPatientPostcode: false,
      invalidPatientMobilePhone: false,
      invalidPatientPhoneNumber: false,
      invalidPostcode: false,
      invalidPhoneNumber: false,
      isComment,
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      saveOldEstimateDetailCode:this.data.oldEstimateDetailCode ? this.data.oldEstimateDetailCode : [], // 旧見積情報（oldEstimateDetailCode）を保存
      saveEstimateDetail:[],// 指示書未選択の情報を格納
      isComment,
      isEscrow,
      medicalInstitutionCode,
      escrowStockList,
      stockItemNameList,
      stockItemCodeList,
      stockItemSeialList,
      prescriptionHardwareList,
      kinds:"",
      serialExchangeFlag:false,
      onlyCollectionFlag:false,
      tempDeviceSelectFlag: false,
      existingFlag:this.data.existingFlag
    };
  },
  components: {
    quotationSelectModal:QuotationSelectModal,
    quotationBulkSelectModal:QuotationBulkSelectModal,
    cpapOrderSelectModal:CpapOrderSelectModal,
    patientSelectModal:PatientSelectModal,
    cpapMaskSelectModal:CpapMaskSelectModal,
    cpapStockModal:CpapStockModal,
    instrumentSelectModal:InstrumentSelectModal,
    EscrowInstrumentSelectModal, // 院内在庫からの選択については2024年に持ち越し（フィリップス佐藤様より）
  },
  filters: {
    codeToValueFilter: function(val, list){
      var target = list.find(item => item.code == val)
      if(target){
        return target.name
      }
      return ""
    }
  },
  mounted: async function() {
    // 診療科コード取得
    await this.gatDepartmentCode()
    if(this.webHtApiErr) return

    // CPAP汎用コードマスタ取得
    await this.gatCodeMasterList()
    if(this.webHtApiErr) return

    await this.getDepositoryCodeMaster()
    if(this.webHtApiErr) return

    // QA337_支店回覧で得意先区分をデフォルトで在宅にする
    // 転院元の得意先区分は引き継がない
    if (!this.data.customerClass || this.resume) {
      const targetClass = this.customerCategory.find(val => val.text == "在宅")
      this.data.customerClass = targetClass.value;
    }

    // モデム同時交換チェック
    this.moduleSimultaneousExchange()

    this.getDirectionsItemList()

    this.setDirectionsItemList()

    // 預託処方変更の場合、預託機使用フラグオン
    if (this.isEscrow) {
      this.data.depositUseFlag = true;
    };

    //QA308_移行患者の処方変更時、必須項目の入力内容に不備がある件
    // 本番障害のため緊急切り戻し（以下の4行のみのためコメントアウト）
    // for(var i=0; i<this.data.prescriptionItems.length; i++){
    //   var item = this.data.prescriptionItems[i]
    //   this.changeSelect(item.displayName,item.value,item.itemName)
    // }

    // シリアル交換を判断　預託処方変更2023.12.11
    this.serialExchangeCheck();

    this.invalidPatientPostcode = isNaN(Number(this.data.patient.zip));
    this.invalidPatientMobilePhone = isNaN(Number(this.data.patient.mobilePhone));
    this.invalidPatientPhoneNumber = isNaN(Number(this.data.patient.phoneNumber));
    this.invalidPostcode = isNaN(Number(this.data.zip));
    this.invalidPhoneNumber = isNaN(Number(this.data.phoneNumber));
  },
  created: function() {
    this.$validator.extend("validationCheck", {
      getMessage: field => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, indexArray) => {
        var ret = false;
        var value = indexArray[0];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";

        if (value.indexOf("'") != -1) {
          // シングルコーテーションはサーバ側でSQLエラーとなる為、ここではじく
          return false;
        }

        for (var i = 1; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      }
    });
  },
  watch: {
    "data.patient.zip" (newValue) {
      this.invalidPatientPostcode = isNaN(Number(newValue));
    },
    "data.patient.mobilePhone" (newValue) {
      this.invalidPatientMobilePhone = isNaN(Number(newValue));
    },
    "data.patient.phoneNumber" (newValue) {
      this.invalidPatientPhoneNumber = isNaN(Number(newValue));
    },
    "data.zip" (newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "data.phoneNumber" (newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
  },
};
</script>
<style lang="scss" scoped>
#item-contens table tr{
  height: 35px;
}
#item-contens table select{
  height: 30px;
}
#prescriptionTable th{
  width:280px;
}
#editMark{
  width:50px;
  vertical-align: middle;
}
.clearBtn {
  margin-left: 5px;
  height: 27px !important;
  width: 27px !important;
}
.change::after {
  position: static;
}
.emphasis {
  background-color: aquamarine;
}
.notice {
  font-size:18px;
  text-align:left;
  color: rgb(62, 125, 197);
  font-weight: bold;
  margin: 10px 50px 20px 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/CpapRequestDetailEdit.vue